import { intersection } from "lodash";

function outcomesLink(organization_name, section) {
  return "/organizations/" + organization_name + "/outcomes" + section;
}

function postOutcomesLink(organization_name, section) {
  return "/organizations/" + organization_name + "/outcomes/post" + section;
}

const DATES = "dates";
const FACILITIES = "facilities";
const CATEGORIES = "categories";
const ALL_FILTERS = [DATES, FACILITIES, CATEGORIES];

export default function metricDefinitions(organization_name, permissions) {
  const { services } = permissions;
  let metrics = {
    general: {
      link: outcomesLink(organization_name, ""),
      name: "General",
      enabledFilters: ALL_FILTERS,
      visible: true,
      metrics: [
        {
          title: "The Number of Clients Who Downloaded the Client App",
          outcome_slug: "general_ncwda",
          description:
              "The total number of clients who downloaded the client app",
          format: "number_horizontal_full",
          endpoint: "number_of_clients_downloaded_app",
          visible: true,
        },
        {
          title: "Net Promoter Score (NPS)",
          outcome_slug: "general_nps",
          description:
              "Net Promoter Score is calculated based on the NPS formula using the submissions of the Haven At College Survey submitted within the filter range",
          format: "number_horizontal_full",
          endpoint: "haven_at_college_nps",
          visible: permissions.haven_at_college_nps,
        },
        {
          title: "Number of clients who were admitted during selected date range",
          outcome_slug: "general_noa",
          description:
              "Number of Clients where admitted at date is within the filter range.",
          format: "number_horizontal_full",
          endpoint: "number_of_admissions",
          visible: true,
        },
        {
          title: "Number of clients who were readmitted during selected date range",
          description:
              "Number of Clients where readmitted at date is within the filter range.",
          format: "number_horizontal_full",
          endpoint: "number_of_readmissions",
          visible: true,
        },
        {
          title: "Successes During Length Of Stay",
          outcome_slug: "general_success_during_stay",
          description:
              "Number of times clients were discharged and were marked as successful discharges.",
          format: "number_horizontal_full",
          endpoint: "number_of_successes",
          visible: true,
        },
        {
          title: "Number of empty beds during selected date range",
          description:
              "Number of beds that are not used at any point during this range.",
          format: "number_horizontal_full",
          endpoint: "number_of_empty_beds",
          visible: true,
        },
        {
          title: "Number of beds being used during selected date range",
          description:
              "Number of beds that are used at any point during this range.",
          format: "number_horizontal_full",
          endpoint: "number_of_full_beds",
          visible: true,
        },
        {
          title: "% of Beds Filled in a Facility",
          description: "",
          format: "number_horizontal_full",
          endpoint: "percentage_of_beds_filled_in_facility",
          visible: true
        },
        {
          title: "Number of Male beds available",
          description:
              "Number of Male beds available",
          format: "number_horizontal_full",
          endpoint: "number_of_male_beds",
          visible: true,
        },
        {
          title: "Number of Female beds available",
          description:
              "Number of Female beds available",
          format: "number_horizontal_full",
          endpoint: "number_of_female_beds",
          visible: true,
        }
      ],
    },
    "client count": {
      link: outcomesLink(organization_name, "/client_count"),
      name: "Client Count",
      enabledFilters: ALL_FILTERS,
      visible: true,
      metrics: [
        {
          title: "Average number of clients admitted during selected date range",
          outcome_slug: "client_count_acc",
          description:
              "Average number of clients admitted within the filter range.",
          format: "number_horizontal_full",
          endpoint: "average_clients_count",
          visible: true,
        },
        {
          title: "Clients",
          description: "",
          outcome_slug: "client_count_cc",
          dataKey: "number_of_clients",
          format: "line_graph",
          endpoint: "current_clients",
          visible: true,
        },
        {
          title: "Logged in Clients Count",
          description: "",
          outcome_slug: "client_count_lcc",
          dataKey: "number_of_clients",
          format: "number_horizontal_full",
          endpoint: "logged_in_clients",
          visible: true,
        },
        {
          title: "Client Count per month",
          description: "",
          outcome_slug: "client_count_ccpm",
          dataKey: "Number of clients",
          format: "line_graph",
          endpoint: "current_clients_per_month",
          visible: true,
        },
      ],
    },
    demographics: {
      link: outcomesLink(organization_name, "/demographics"),
      name: "Demographics",
      visible: true,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Degree at Move In",
          description: "",
          format: "bar_graph",
          endpoint: "education_degree_upon_move_in",
          visible: true,
        },
        {
          title: "Degree at Move Out",
          description: "",
          format: "bar_graph",
          endpoint: "education_degree_move_out",
          visible: true,
        },
        {
          title: "Living Arrangements at Move In",
          description: "",
          format: "bar_graph",
          endpoint: "living_arrangement_move_in",
          visible: true,
        },
        {
          title: "Living Arrangements at Move Out",
          description: "",
          format: "bar_graph",
          endpoint: "living_arrangement_move_out",
          visible: true,
        },
        {
          title: "Marital status",
          outcome_slug: "demographics_ms",
          demographic: "marital_status",
          format: "pie_chart",
          description: "",
        },
        {
          title: "Number of Clients on Probation",
          outcome_slug: "demographics_cop",
          demographic: "clients_on_probation",
          format: "number_horizontal_full",
          description: "",
        },
        {
          title: "Number of Clients Who Successfully Completed Probation",
          outcome_slug: "demographics_csp",
          demographic: "successful_probation",
          format: "number_horizontal_full",
          description: "",
        },
        {
          title: "Number of discharged clients with sponsors",
          outcome_slug: "demographics_ds",
          demographic: "discharge_sponsor",
          format: "pie_chart",
          description: "",
        },
        {
          title: "Race",
          outcome_slug: "demographics_r",
          demographic: "race",
          format: "pie_chart",
          description: "",
        },
        {
          title: "Average age",
          outcome_slug: "demographics_age",
          demographic: "age",
          format: "number_horizontal",
        },
        {
          title: "Age Range of Clients",
          outcome_slug: "demographics_age_ranges",
          demographic: "age_ranges",
          format: "pie_chart",
        },
        {
          title: "Genders of Clients",
          outcome_slug: "demographics_g",
          demographic: "gender",
          format: "pie_chart_large",
          description: "",
        },
        {
          title: "Ethnicity of Clients",
          outcome_slug: "demographics_eth",
          demographic: "ethnicity",
          format: "pie_chart_large",
          description: "",
        },
        {
          title: "Veteran Status of Clients",
          outcome_slug: "demographics_ve",
          demographic: "veteran_status",
          format: "pie_chart_large",
          description: "",
        },
        {
          title: "Employment Status of Clients",
          outcome_slug: "demographics_em",
          demographic: "employment",
          format: "vertical_bar_graph",
          description: "",
        },
        {
          title: "Income Level Upon Move In",
          description:
              "Income levels of clients upon Admit Date",
          format: "bar_graph",
          endpoint: "income_level_upon_move_in",
          visible: true,
        },
        {
          title: "Income Level Upon Move Out",
          description:
              "Income levels of clients upon Discharge Date",
          format: "bar_graph",
          endpoint: "income_level_upon_move_out",
          visible: true,
        },
        {
          title: "Number Employed Clients Upon Admit",
          outcome_slug: "employment_upon_admit",
          description:
              "Number Employed Clients upon admit of all clients that were in the program at some point within the filter range.",
          format: "number_horizontal_large",
          endpoint: "count_employment_upon_move_in",
          visible: true,
        },
        {
          title: "Number Employed Clients Upon Discharge",
          outcome_slug: "employment_upon_discharge",
          description:
              "Number Employed Clients Upon Discharge of all clients that were in the program at some point within the filter range.",
          format: "number_horizontal_large",
          endpoint: "count_employment_upon_move_out",
          visible: true,
        },
        {
          title: "% of Clients who have an Employment Start Date during Admission to a Facility",
          description: "",
          format: "number_horizontal_full",
          endpoint: "percentage_of_clients_with_employment_start_date_during_admission",
          visible: true,
        },
        {
          title: "% of Clients who have an Increase in Income during Admission to a Facility",
          description: "",
          format: "number_horizontal_full",
          endpoint: "percentage_of_clients_with_increase_in_income_during_admission",
          visible: true,
        },
        {
          title: "Average # of Children per Client",
          description: "",
          format: "number_horizontal_full",
          endpoint: "average_number_of_children_per_client",
          visible: true,
        },
        {
          title: "Average Age of Child per Client",
          description: "",
          format: "number_horizontal_full",
          endpoint: "average_age_of_children_per_client",
          visible: true,
        },
      ],
    },
    surveys: {
      link: outcomesLink(organization_name, "/surveys"),
      name: "Surveys",
      visible: permissions.surveys.visible,
      enabledFilters: ALL_FILTERS,
      averageMetrics: [
        {
          endpoint: "average_score_in_general",
          title: "Discharge Program Evaluation",
          visible: permissions.surveys.discharge_program_evaluation,
          slug: "discharge_program_evaluation",
        },
        {
          endpoint: "average_score_in_general",
          title: "Why Not Prosper: Beck's Depression Inventory",
          visible: permissions.surveys.wnp_bdi,
          slug: "wnp-bdi",
        },
        {
          endpoint: "average_score_in_general",
          title: "Admission Program Evaluation",
          visible: permissions.surveys.admission_program_evaluation,
          slug: "admission_program_evaluation",
        },
        {
          endpoint: "average_score_in_general",
          title: "Exit Survey",
          visible: permissions.surveys.bayshore_exit_survey,
          slug: "bayshore-exit-survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Member Satisfaction Survey",
          visible: permissions.surveys.sl_mss,
          slug: "sl-mss",
        },
        {
          endpoint: "average_score_in_general",
          title: "ACEs",
          visible: permissions.surveys.ace,
          slug: "ace",
        },
        {
          endpoint: "average_score_in_general",
          title: "Infant Daily Measure",
          visible: permissions.surveys.mhidm,
          slug: "mhidm",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse Sobriety Survey",
          visible: permissions.surveys.safehouse_sobriety,
          slug: "safehouse-sobriety",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse 12 Step Survey",
          visible: permissions.surveys.safehouse_twelve_step_other,
          slug: "safehouse-12-step-other",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse 12 Step Survey(OLD)",
          visible: permissions.surveys.safehouse_twelve_step,
          slug: "safehouse-12-step",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse Community Survey",
          visible: permissions.surveys.safehouse_community,
          slug: "safehouse-community",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse Education Survey",
          visible: permissions.surveys.safehouse_education,
          slug: "safehouse-education",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse Financial Survey",
          visible: permissions.surveys.safehouse_financial,
          slug: "safehouse-financial",
        },
        {
          endpoint: "average_score_in_general",
          title: "Safehouse Spiritual Survey",
          visible: permissions.surveys.safehouse_spiritual,
          slug: "safehouse-spiritual",
        },
        {
          endpoint: "average_score_in_general",
          title: "Academics Anonymous",
          visible: permissions.surveys.acan,
          slug: "acan",
        },
        {
          endpoint: "average_score_in_general",
          title: "Past Participant Check In",
          visible: permissions.surveys.tribe_ppci,
          slug: "tribe-ppci",
        },
        {
          endpoint: "average_score_in_general",
          title: "Outcomes Assessment",
          visible: permissions.surveys.hi_oa,
          slug: "hi-oa",
        },
        {
          endpoint: "average_score_in_general",
          title: "DAST: Drug Abuse Screening Test",
          visible: permissions.surveys.hi_dast,
          slug: "hi-dast",
        },
        {
          endpoint: "average_score_in_general",
          title: "CAGE",
          visible: permissions.surveys.hi_cage,
          slug: "hi-cage",
        },
        {
          endpoint: "average_score_in_general",
          title: "AUDIT",
          visible: permissions.surveys.hi_audit,
          slug: "hi-audit",
        },
        {
          endpoint: "average_score_in_general",
          title: "MAST",
          visible: permissions.surveys.hi_mast,
          slug: "hi-mast",
        },
        {
          endpoint: "average_score_in_general",
          title: "Treatment Ratings",
          visible: permissions.surveys.hi_tr,
          slug: "hi-tr",
        },
        {
          endpoint: "average_score_in_general",
          title: "Reflecting on Parenting Support",
          visible: permissions.surveys.mhrps,
          slug: "mhrps",
        },
        {
          endpoint: "average_score_in_general",
          title: "Recovery Capital Scale",
          visible: permissions.surveys.rur_rcs,
          slug: "rur-rcs",
        },
        {
          endpoint: "average_score_in_general",
          title: "Wheel of Life",
          visible: permissions.surveys.cceok_wof,
          slug: "cceok-wof",
        },
        {
          endpoint: "average_score_in_general",
          title: "Credit score",
          visible: permissions.surveys.cceok_cs,
          slug: "cceok-cs",
        },
        {
          endpoint: "average_score_in_general",
          title: "Initial 72-hour survey",
          visible: permissions.surveys.br_i72hs,
          slug: "br-i72hs",
        },
        {
          endpoint: "average_score_in_general",
          title: "TLR Alumni Survey",
          visible: permissions.surveys.lr_tlr,
          slug: "lr-tlr",
        },
        {
          endpoint: "average_score_in_general",
          title: "RC36 Survey",
          visible: permissions.surveys.rc_36,
          slug: "rc_36",
        },
        {
          endpoint: "average_score_in_general",
          title: "30 Days - Admission Survey",
          visible: permissions.surveys.as_rpwv,
          slug: "as_rpwv",
        },
        {
          endpoint: "average_score_in_general",
          title: "30 Days - Discharge Survey",
          visible: permissions.surveys.ad_rpwv,
          slug: "ad_rpwv",
        },
        {
          endpoint: "average_score_in_general",
          title: "Peer Session Entry Form",
          visible: permissions.surveys.docs_recovery,
          slug: "docs_recovery",
        },
        {
          endpoint: "average_score_in_general",
          title: "Legal Survey",
          visible: permissions.surveys.legal_survey,
          slug: "legal_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Threshold Recovery Survey Transportation Log",
          visible: permissions.surveys.recovery_survey_transportation_log,
          slug: "recovery_survey_transportation_log",
        },
        {
          endpoint: "average_score_in_general",
          title: "Phase 3 Checkin",
          visible: permissions.surveys.phase_3_checkin,
          slug: "phase_3_checkin",
        },
        {
          endpoint: "average_score_in_general",
          title: "Weekly Checkin",
          visible: permissions.surveys.weekly_checkin,
          slug: "weekly_checkin",
        },
        {
          endpoint: "average_score_in_general",
          title: "Career Coach",
          visible: permissions.surveys.career_coach,
          slug: "career_coach",
        },
        {
          endpoint: "average_score_in_general",
          title: "Threshold Recovery Capital: Initial Assessment",
          visible: permissions.surveys.threshold_recovery_capital,
          slug: "threshold_recovery_capital",
        },
        {
          endpoint: "average_score_in_general",
          title: "Transportation Driver Survey",
          visible: permissions.surveys.transportation_driver_survey,
          slug: "transportation_driver_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Flourishing Measure Survey",
          visible: permissions.surveys.fm,
          slug: "fm",
        },
        {
          endpoint: "average_score_in_general",
          title: "Alcohol Abstinence Self-Efficacy Scale (AASE)",
          visible: permissions.surveys.aase_20,
          slug: "aase-20",
        },
        {
          endpoint: "average_score_in_general",
          title: "NEATC Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_neatc,
          slug: "ark_beh_neatc",
        },
        {
          endpoint: "average_score_in_general",
          title: "BEDROCK Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_bedrock,
          slug: "ark_beh_bedrock",
        },
        {
          endpoint: "average_score_in_general",
          title: "RCI Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_rci,
          slug: "ark_beh_rci",
        },
        {
          endpoint: "average_score_in_general",
          title: "SPRING HILL Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_spring_hill,
          slug: "ark_beh_spring_hill",
        },
        {
          endpoint: "average_score_in_general",
          title: "Assessment of Recovery Capital Survey",
          visible: permissions.surveys.as_rc,
          slug: "as-rc",
        },
        {
          endpoint: "average_score_in_general",
          title: "Perceived Stress Questionnaire Survey",
          visible: permissions.surveys.fm_psq,
          slug: "fm_psq",
        },
        {
          endpoint: "average_score_in_general",
          title: "Participant Satisfaction",
          visible: permissions.surveys.participant_satisfaction,
          slug: "participant_satisfaction",
        },
        {
          endpoint: "average_score_in_general",
          title: "Client Satisfaction Survey",
          visible: permissions.surveys.client_satisfaction,
          slug: "client_satisfaction",
        },
        {
          endpoint: "average_score_in_general",
          title: "Exit Interview Questionnaire",
          visible: permissions.surveys.exit_interview_questionnaire,
          slug: "exit_interview_questionnaire",
        },
        {
          endpoint: "average_score_in_general",
          title: "Participant Satisfaction",
          visible: permissions.surveys.participant_satisfaction_survey,
          slug: "participant_satisfaction_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "ACE Extension",
          visible: permissions.surveys.ace_extension,
          slug: "ace_extension",
        },
        {
          endpoint: "average_score_in_general",
          title: "RECCAP Survey",
          visible: permissions.surveys.reccap,
          slug: "reccap",
        },
        {
          endpoint: "average_score_in_general",
          title: "Ethos Discharge Survey",
          visible: permissions.surveys.ethos_discharge_survey,
          slug: "ethos_discharge_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "The Adult Hope Scale",
          visible: permissions.surveys.adult_hope_scale,
          slug: "adult_hope_scale",
        },
        {
          endpoint: "average_score_in_general",
          title: "Peer Support Session",
          visible: permissions.surveys.peer_support_session,
          slug: "peer_support_session"
        },
        {
          endpoint: "average_score_in_general",
          title: "Discharge Survey",
          visible: permissions.surveys.discharge_survey,
          slug: "discharge_survey"
        },
        {
          endpoint: "average_score_in_general",
          title: "Would You Recommend Us?",
          visible: permissions.surveys.would_you_recommend_us,
          slug: "would_you_recommend_us"
        },
        {
          endpoint: "average_score_in_general",
          title: "RCI - 36",
          visible: permissions.surveys.rci_36,
          slug: "rci_36"
        },
        {
          endpoint: "average_score_in_general",
          title: "Donation Application",
          visible: permissions.surveys.donation_application,
          slug: "donation_application",
        },
        {
          endpoint: "average_score_in_general",
          title: "Truly Motivational Transitional Living",
          visible: permissions.surveys.truly_motivational_transitional_living,
          slug: "truly_motivational_transitional_living",
        },
        {
          endpoint: "average_score_in_general",
          title: "Case Management Survey",
          visible: permissions.surveys.case_management_survey,
          slug: "case_management_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Reentry Personal Survey",
          visible: permissions.surveys.reentry_personal_survey,
          slug: "reentry_personal_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Intake Benchmark Survey",
          visible: permissions.surveys.intake_benchmark_survey,
          slug: "intake_benchmark_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "QQ - 45.2",
          visible: permissions.surveys.qq_45_2,
          slug: "qq_45_2",
        },
        {
          endpoint: "average_score_in_general",
          title: "Interval Satisfaction & Progress Survey (30, 60, 90 Days, etc.)",
          visible: permissions.surveys.interval_satisfaction_progress,
          slug: "interval_satisfaction_progress",
        },
        {
          endpoint: "average_score_in_general",
          title: "Emotional Sustainability and Resilience Assessment",
          visible: permissions.surveys.emotional_sustainability_resilience_assessment,
          slug: "emotional_sustainability_resilience_assessment",
        },
        {
          endpoint: "average_score_in_general",
          title: "MHA Sober Living Feedback Survey",
          visible: permissions.surveys.mha_sober_living_feedback_survey,
          slug: "mha_sober_living_feedback_survey"
        },
        {
          endpoint: "average_score_in_general",
          title: "Toni House Exit Interview Survey",
          visible: permissions.surveys.toni_house_exit_interview_survey,
          slug: "toni_house_exit_interview_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Stable Recovery Evaluations",
          visible: permissions.surveys.stable_recovery_evaluations,
          slug: "stable_recovery_evaluations",
        },
        {
          endpoint: "average_score_in_general",
          title: "SriPonya Group Services Survey",
          visible: permissions.surveys.pirs_group_services,
          slug: "pirs_group_services",
        },
        {
          endpoint: "average_score_in_general",
          title: "Fairview Housing Resident Satisfaction Survey",
          visible: permissions.surveys.fairview_housing_resident_satisfaction_survey,
          slug: "fairview_housing_resident_satisfaction_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Family Recovery Course - Baseline Survey",
          visible: permissions.surveys.frc_baseline_survey,
          slug: "frc_baseline_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Family Recovery Course - Follow Up Survey",
          visible: permissions.surveys.frc_follow_up_survey,
          slug: "frc_follow_up_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "Family Recovery Course - Final Survey",
          visible: permissions.surveys.frc_final_survey,
          slug: "frc_final_survey",
        },
        {
          endpoint: "average_score_in_general",
          title: "HOPE HOUSE PATHWAYS PROGRAM",
          visible: permissions.surveys.hope_house_pathways_program,
          slug: "hope_house_pathways_program",
        },
        {
          endpoint: "average_score_in_general",
          title: "PCL-5",
          visible: permissions.surveys.pcl5,
          slug: "pcl5",
        },
        ...[{
          name: 'Social Support',
          slug: 'ss'
        }, {
          name: 'Problem Solving',
          slug: 'ps'
        }, {
          name: 'Depression',
          slug: 'd'
        }, {
          name: 'Personal Care',
          slug: 'pc'
        }, {
          name: 'Mobilizing Resources',
          slug: 'mr'
        }, {
          name: 'Role Satisfaction',
          slug: 'rs'
        }, {
          name: 'Parent/Child Interaction',
          slug: 'pci'
        }, {
          name: 'Home Environment',
          slug: 'he'
        }, {
          name: 'Parenting Efficacy',
          slug: 'pe'
        }].map((survey) => {
          return {
            endpoint: "average_score_in_general",
            title: `Healthy Families Parenting Inventory - ${survey.name}`,
            visible: permissions.surveys[`cceok_hfpi_${survey.slug}`],
            slug: `cceok-hfpi-${survey.slug}`,
          };
        }),
        {
          endpoint: "average_score_in_general",
          title: "25 - Item Resilience Scale Survey",
          visible: permissions.surveys.rbh_rs,
          slug: "rbh-rs",
        },
        {
          endpoint: "average_score_in_general",
          title: "The Trait Hope Scale Survey",
          visible: permissions.surveys.rbh_ths,
          slug: "rbh-ths",
        },
        {
          endpoint: "average_score_in_general",
          title: "Multidimensional Scale of Perceived Social Support Survey",
          visible: permissions.surveys.rbh_msp,
          slug: "rbh-msp",
        },
        {
          endpoint: "average_score_in_general",
          title: "Trauma Symptom Checklist Survey",
          visible: permissions.surveys.rbh_tsc,
          slug: "rbh-tsc",
        },
        ...[{
          name: 'Residential Treatment',
          slug: 'rt'
        }, {
          name: 'Detox Treatment',
          slug: 'dt'
        }, {
          name: 'Behavioral Wellness Outpatient Services',
          slug: 'bwos'
        }, {
          name: 'Recovery Housing',
          slug: 'rh'
        }, {
          name: 'New Dawn Family Healing',
          slug: 'ndfh'
        }].map((survey) => {
          return {
            endpoint: "average_score_in_general",
            title: `Member Satisfaction Survey - ${survey.name}`,
            visible: permissions.surveys[`mss_${survey.slug}`],
            slug: `mss_${survey.slug}`,
          };
        }),
      ],
      percentChangeMetrics: [
        {
          endpoint: "average_percent_change",
          title: "CPR Exit Survey",
          visible: permissions.surveys.cpr_es,
          slug: "cpr-es",
        },
        {
          endpoint: "average_percent_change",
          title: "Discharge Program Evaluation",
          visible: permissions.surveys.discharge_program_evaluation,
          slug: "discharge_program_evaluation",
        },
        {
          endpoint: "average_percent_change",
          title: "Personal Wellness Assessment",
          visible: permissions.surveys.pwa_8,
          slug: "pwa-8",
        },
        {
          endpoint: "average_percent_change",
          title: "Admission Program Evaluation",
          visible: permissions.surveys.admission_program_evaluation,
          slug: "admission_program_evaluation",
        },
        {
          endpoint: "average_percent_change",
          title: "Catholic Charities: Stability Factors",
          visible: permissions.surveys.mhsf,
          slug: "mhsf",
        },
        {
          endpoint: "average_percent_change",
          title: "Catholic Charities: Supplemental Stability Factors",
          visible: permissions.surveys.mhssf,
          slug: "mhssf",
        },
        {
          endpoint: "average_percent_change",
          title: "Catholic Charities: Pregnancy/Parenting Factors",
          visible: permissions.surveys.mhppf,
          slug: "mhppf",
        },
        {
          endpoint: "average_percent_change",
          title: "DASS 21",
          visible: permissions.surveys.dass_21,
          slug: "dass-21",
        },
        {
          endpoint: "average_percent_change",
          title: "Exit Survey",
          visible: permissions.surveys.bayshore_exit_survey,
          slug: "bayshore-exit-survey",
        },
        {
          endpoint: "average_percent_change",
          title: "CISS",
          visible: permissions.surveys.ciss,
          slug: "ciss",
        },
        {
          endpoint: "average_percent_change",
          title: "PCL",
          visible: permissions.surveys.pcl,
          slug: "pclc",
        },
        {
          endpoint: "average_percent_change",
          title: "PHQ",
          visible: permissions.surveys.phq,
          slug: "phq9",
        },
        {
          endpoint: "average_percent_change",
          title: "GAD",
          visible: permissions.surveys.gad,
          slug: "gad7",
        },
        {
          endpoint: "average_percent_change",
          title: "DLA",
          visible: permissions.surveys.dla,
          slug: "dla-20",
        },
        {
          endpoint: "average_percent_change",
          title: "Sana Lake BARC-10",
          visible: permissions.surveys.sl_barc_10,
          slug: "sl-barc-10",
        },
        {
          endpoint: "average_percent_change",
          title: "BARC-10",
          visible: permissions.surveys.barc_10,
          slug: "barc-10",
        },
        {
          endpoint: "average_percent_change",
          title: "ACEs",
          visible: permissions.surveys.ace,
          slug: "ace",
        },
        {
          endpoint: "average_percent_change",
          title: "Infant Daily Measure",
          visible: permissions.surveys.mhidm,
          slug: "mhidm",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse Sobriety",
          visible: permissions.surveys.safehouse_sobriety,
          slug: "safehouse-sobriety",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse 12 Step",
          visible: permissions.surveys.safehouse_twelve_step_other,
          slug: "safehouse-12-step-other",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse 12 Step(OLD)",
          visible: permissions.surveys.safehouse_twelve_step,
          slug: "safehouse-12-step",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse Community",
          visible: permissions.surveys.safehouse_community,
          slug: "safehouse-community",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse Education",
          visible: permissions.surveys.safehouse_education,
          slug: "safehouse-education",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse Financial",
          visible: permissions.surveys.safehouse_financial,
          slug: "safehouse-financial",
        },
        {
          endpoint: "average_percent_change",
          title: "Safehouse Spiritual",
          visible: permissions.surveys.safehouse_spiritual,
          slug: "safehouse-spiritual",
        },
        {
          endpoint: "average_percent_change",
          title: "Academics Anonymous",
          visible: permissions.surveys.acan,
          slug: "acan",
        },
        {
          endpoint: "average_percent_change",
          title: "Past Participant Check In",
          visible: permissions.surveys.tribe_ppci,
          slug: "tribe-ppci",
        },
        {
          endpoint: "average_percent_change",
          title: "Outcomes Assessment",
          visible: permissions.surveys.hi_oa,
          slug: "hi-oa",
        },
        {
          endpoint: "average_percent_change",
          title: "DAST: Drug Abuse Screening Test",
          visible: permissions.surveys.hi_dast,
          slug: "hi-dast",
        },
        {
          endpoint: "average_percent_change",
          title: "CAGE",
          visible: permissions.surveys.hi_cage,
          slug: "hi-cage",
        },
        {
          endpoint: "average_percent_change",
          title: "AUDIT",
          visible: permissions.surveys.hi_audit,
          slug: "hi-audit",
        },
        {
          endpoint: "average_percent_change",
          title: "MAST",
          visible: permissions.surveys.hi_mast,
          slug: "hi-mast",
        },
        {
          endpoint: "average_percent_change",
          title: "Treatment Ratings",
          visible: permissions.surveys.hi_tr,
          slug: "hi-tr",
        },
        {
          endpoint: "average_percent_change",
          title: "Reflecting on Parenting Support",
          visible: permissions.surveys.mhrps,
          slug: "mhrps",
        },
        {
          endpoint: "average_percent_change",
          title: "Recovery Capital Scale",
          visible: permissions.surveys.rur_rcs,
          slug: "rur-rcs",
        },
        {
          endpoint: "average_percent_change",
          title: "Wheel of Life",
          visible: permissions.surveys.cceok_wof,
          slug: "cceok-wof",
        },
        {
          endpoint: "average_percent_change",
          title: "Wheel of Recovery",
          visible: permissions.surveys.ir_wor,
          slug: "ir_wor",
        },
        {
          endpoint: "average_percent_change",
          title: "Daily Log",
          visible: permissions.surveys.dl_epc,
          slug: "dl_epc",
        },
        {
          endpoint: "average_percent_change",
          title: "Credit score",
          visible: permissions.surveys.cceok_cs,
          slug: "cceok-cs",
        },
        {
          endpoint: "average_percent_change",
          title: "Initial 72-hour survey",
          visible: permissions.surveys.br_i72hs,
          slug: "br-i72hs",
        },
        {
          endpoint: "average_percent_change",
          title: "TLR Alumni Survey",
          visible: permissions.surveys.lr_tlr,
          slug: "lr-tlr",
        },
        {
          endpoint: "average_percent_change",
          title: "Flourishing Measure Survey",
          visible: permissions.surveys.fm,
          slug: "fm",
        },
        {
          endpoint: "average_percent_change",
          title: "Alcohol Abstinence Self-Efficacy Scale (AASE) Survey",
          visible: permissions.surveys.aase_20,
          slug: "aase-20",
        },
        {
          endpoint: "average_percent_change",
          title: "NEATC Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_neatc,
          slug: "ark_beh_neatc",
        },
        {
          endpoint: "average_percent_change",
          title: "BEDROCK Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_bedrock,
          slug: "ark_beh_bedrock",
        },
        {
          endpoint: "average_percent_change",
          title: "RCI Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_rci,
          slug: "ark_beh_rci",
        },
        {
          endpoint: "average_percent_change",
          title: "SPRING HILL Patient-Alumni Survey",
          visible: permissions.surveys.ark_beh_spring_hill,
          slug: "ark_beh_spring_hill",
        },
        {
          endpoint: "average_score_in_general",
          title: "Assessment of Recovery Capital Survey",
          visible: permissions.surveys.as_rc,
          slug: "as-rc",
        },
        {
          endpoint: "average_score_in_general",
          title: "PPM Group Participation Session",
          visible: permissions.surveys.ppm_group_participation_session,
          slug: "ppm_group_participation_session",
        },
        {
          endpoint: "average_percent_change",
          title: "Perceived Stress Questionnaire Survey",
          visible: permissions.surveys.fm_psq,
          slug: "fm_psq",
        },
        {
          endpoint: "average_percent_change",
          title: "RC36",
          visible: permissions.surveys.rc_36,
          slug: "rc_36",
        },
        {
          endpoint: "average_percent_change",
          title: "30 Days - Admission Survey",
          visible: permissions.surveys.as_rpwv,
          slug: "as_rpwv",
        },
        {
          endpoint: "average_percent_change",
          title: "30 Days - Discharge Survey",
          visible: permissions.surveys.ad_rpwv,
          slug: "ad_rpwv",
        },
        {
          endpoint: "average_percent_change",
          title: "Peer Session Entry Form",
          visible: permissions.surveys.docs_recovery,
          slug: "docs_recovery",
        },
        {
          endpoint: "average_percent_change",
          title: "Legal Survey",
          visible: permissions.surveys.legal_survey,
          slug: "legal_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Threshold Recovery Survey Transportation Log",
          visible: permissions.surveys.recovery_survey_transportation_log,
          slug: "recovery_survey_transportation_log",
        },
        {
          endpoint: "average_percent_change",
          title: "Transportation Driver Survey",
          visible: permissions.surveys.transportation_driver_survey,
          slug: "transportation_driver_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Participant Satisfaction",
          visible: permissions.surveys.participant_satisfaction_survey,
          slug: "participant_satisfaction_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Client Satisfaction Survey",
          visible: permissions.surveys.client_satisfaction,
          slug: "client_satisfaction",
        },
        {
          endpoint: "average_score_in_general",
          title: "ACE Extension",
          visible: permissions.surveys.ace_extension,
          slug: "ace_extension",
        },
        {
          endpoint: "average_percent_change",
          title: "PPM Group Participation Session",
          visible: permissions.surveys.ppm_group_participation_session,
          slug: "ppm_group_participation_session",
        },
        {
          endpoint: "average_percent_change",
          title: "Exit Interview Questionnaire",
          visible: permissions.surveys.exit_interview_questionnaire,
          slug: "exit_interview_questionnaire",
        },
        {
          endpoint: "average_percent_change",
          title: "RECCAP Survey",
          visible: permissions.surveys.reccap,
          slug: "reccap",
        },
        {
          endpoint: "average_percent_change",
          title: "Phase 3 Checkin",
          visible: permissions.surveys.phase_3_checkin,
          slug: "phase_3_checkin",
        },
        {
          endpoint: "average_percent_change",
          title: "Weekly Checkin",
          visible: permissions.surveys.weekly_checkin,
          slug: "weekly_checkin",
        },
        {
          endpoint: "average_percent_change",
          title: "Career Coach",
          visible: permissions.surveys.career_coach,
          slug: "career_coach",
        },
        {
          endpoint: "average_percent_change",
          title: "Threshold Recovery Capital: Initial Assessment",
          visible: permissions.surveys.threshold_recovery_capital,
          slug: "threshold_recovery_capital",
        },
        {
          endpoint: "average_percent_change",
          title: "Participant Satisfaction",
          visible: permissions.surveys.participant_satisfaction,
          slug: "participant_satisfaction",
        },
        {
          endpoint: "average_percent_change",
          title: "Peer Support Session",
          visible: permissions.surveys.peer_support_session,
          slug: "peer_support_session",
        },
        {
          endpoint: "average_percent_change",
          title: "Discharge Survey",
          visible: permissions.surveys.discharge_survey,
          slug: "discharge_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Would You Recommend Us?",
          visible: permissions.surveys.would_you_recommend_us,
          slug: "would_you_recommend_us",
        },
        {
          endpoint: "average_percent_change",
          title: "RCI - 36",
          visible: permissions.surveys.rci_36,
          slug: "rci_36",
        },
        {
          endpoint: "average_percent_change",
          title: "Ethos Discharge Survey",
          visible: permissions.surveys.ethos_discharge_survey,
          slug: "ethos_discharge_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "The Adult Hope Scale",
          visible: permissions.surveys.adult_hope_scale,
          slug: "adult_hope_scale",
        },
        {
          endpoint: "average_percent_change",
          title: "Donation Application",
          visible: permissions.surveys.donation_application,
          slug: "donation_application",
        },
        {
          endpoint: "average_percent_change",
          title: "Truly Motivational Transitional Living",
          visible: permissions.surveys.truly_motivational_transitional_living,
          slug: "truly_motivational_transitional_living",
        },
        {
          endpoint: "average_percent_change",
          title: "Case Management Survey",
          visible: permissions.surveys.case_management_survey,
          slug: "case_management_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Reentry Personal Survey",
          visible: permissions.surveys.reentry_personal_survey,
          slug: "reentry_personal_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Intake Benchmark Survey",
          visible: permissions.surveys.intake_benchmark_survey,
          slug: "intake_benchmark_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "QQ - 45.2",
          visible: permissions.surveys.qq_45_2,
          slug: "qq_45_2",
        },
        {
          endpoint: "average_percent_change",
          title: "Interval Satisfaction & Progress Survey (30, 60, 90 Days, etc.)",
          visible: permissions.surveys.interval_satisfaction_progress,
          slug: "interval_satisfaction_progress",
        },
        {
          endpoint: "average_percent_change",
          title: "Emotional Sustainability and Resilience Assessment",
          visible: permissions.surveys.emotional_sustainability_resilience_assessment,
          slug: "emotional_sustainability_resilience_assessment",
        },
        {
          endpoint: "average_percent_change",
          title: "MHA Sober Living Feedback Survey",
          visible: permissions.surveys.mha_sober_living_feedback_survey,
          slug: "mha_sober_living_feedback_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Toni House Exit Interview Survey",
          visible: permissions.surveys.toni_house_exit_interview_survey,
          slug: "toni_house_exit_interview_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "SriPonya Group Services Survey",
          visible: permissions.surveys.pirs_group_services,
          slug: "pirs_group_services",
        },
        {
          endpoint: "average_percent_change",
          title: "Fairview Housing Resident Satisfaction Survey",
          visible: permissions.surveys.fairview_housing_resident_satisfaction_survey,
          slug: "fairview_housing_resident_satisfaction_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Family Recovery Course - Baseline Survey",
          visible: permissions.surveys.frc_baseline_survey,
          slug: "frc_baseline_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Family Recovery Course - Follow Up Survey",
          visible: permissions.surveys.frc_follow_up_survey,
          slug: "frc_follow_up_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "Family Recovery Course - Final Survey",
          visible: permissions.surveys.frc_final_survey,
          slug: "frc_final_survey",
        },
        {
          endpoint: "average_percent_change",
          title: "HOPE HOUSE PATHWAYS PROGRAM",
          visible: permissions.surveys.hope_house_pathways_program,
          slug: "hope_house_pathways_program",
        },
        {
          endpoint: "average_percent_change",
          title: "PCL-5",
          visible: permissions.surveys.pcl5,
          slug: "pcl5",
        },
        {
          endpoint: "average_percent_change",
          title: "Stable Recovery Evaluations",
          visible: permissions.surveys.stable_recovery_evaluations,
          slug: "stable_recovery_evaluations",
        },
        ...[{
          name: 'Social Support',
          slug: 'ss'
        }, {
          name: 'Problem Solving',
          slug: 'ps'
        }, {
          name: 'Depression',
          slug: 'd'
        }, {
          name: 'Personal Care',
          slug: 'pc'
        }, {
          name: 'Mobilizing Resources',
          slug: 'mr'
        }, {
          name: 'Role Satisfaction',
          slug: 'rs'
        }, {
          name: 'Parent/Child Interaction',
          slug: 'pci'
        }, {
          name: 'Home Environment',
          slug: 'he'
        }, {
          name: 'Parenting Efficacy',
          slug: 'pe'
        }].map((survey) => {
          return {
            endpoint: "average_percent_change",
            title: `Healthy Families Parenting Inventory - ${survey.name}`,
            visible: permissions.surveys[`cceok_hfpi_${survey.slug}`],
            slug: `cceok-hfpi-${survey.slug}`,
          };
        }),
        ...[{
          name: 'Residential Treatment',
          slug: 'rt'
        }, {
          name: 'Detox Treatment',
          slug: 'dt'
        }, {
          name: 'Behavioral Wellness Outpatient Services',
          slug: 'bwos'
        }, {
          name: 'Recovery Housing',
          slug: 'rh'
        }, {
          name: 'New Dawn Family Healing',
          slug: 'ndfh'
        }].map((survey) => {
          return {
            endpoint: "average_percent_change",
            title: `Member Satisfaction Survey - ${survey.name}`,
            visible: permissions.surveys[`mss_${survey.slug}`],
            slug: `mss_${survey.slug}`,
          };
        }),
      ],
      averageScorePerMonthMetrics: [
        {
          endpoint: "average_score_in_general_per_month",
          title: "ASAM Survey",
          visible: permissions.surveys.asam,
          slug: "asam"
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Discharge Program Evaluation",
          visible: permissions.surveys.discharge_program_evaluation,
          slug: "discharge_program_evaluation"
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Bayshore Exit Survey Score",
          description:
              "Average score of clients who took at least one exit Bayshore Exit Survey. This metric takes into account Bayshore Exit Survey submissions and calculates the average score",
          visible: permissions.surveys.bayshore_exit_survey,
          slug: "bayshore-exit-survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Admission Program Evaluation",
          visible: permissions.surveys.admission_program_evaluation,
          slug: "admission_program_evaluation"
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "ACE Survey Score",
          description:
              "Average score of clients who took at least one exit ACEs Survey. This metric takes into account ACEs submissions and calculates the average score",
          visible: permissions.surveys.ace,
          slug: "ace",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Infant Daily Measure",
          description:
              "Average score of clients who took at least one exit Infant Daily Measure. This metric takes into account Infant Daily Measure submissions and calculates the average score",
          visible: permissions.surveys.mhidm,
          slug: "mhidm",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse Sobriety",
          description:
              "Average score of clients who took at least one exit Safehouse Sobriety Survey. This metric takes into account Safehouse Sobriety Survey submissions and calculates the average score",
          visible: permissions.surveys.safehouse_sobriety,
          slug: "safehouse-sobriety",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse 12 Step",
          description:
              "Average score of clients who took at least one exit Safehouse 12 Step Survey. This metric takes into account Safehouse 12 Step Survey submissions and calculates the average score",
          visible: permissions.surveys.safehouse_twelve_step_other,
          slug: "safehouse-12-step-other",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse 12 Step(OLD)",
          description:
              "Average score of clients who took at least one exit Safehouse 12 Step Survey. This metric takes into account Safehouse 12 Step Survey submissions and calculates the average score",
          visible: permissions.surveys.safehouse_twelve_step,
          slug: "safehouse-12-step",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse Community",
          description:
              "Average score of clients who took at least one exit Safehouse Community Survey. This metric takes into account Safehouse Community Survey submissions and calculates the average score",
          visible: permissions.surveys.safehouse_community,
          slug: "safehouse-community",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse Education",
          description:
              "Average score of clients who took at least one exit Safehouse Education Survey. This metric takes into account Safehouse Education Survey submissions and calculates the average score",
          visible: permissions.surveys.safehouse_education,
          slug: "safehouse-education",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse Financial",
          description:
              "Average score of clients who took at least one exit Safehouse Financial Survey. This metric takes into account Safehouse Sobriety Financial submissions and calculates the average score",
          visible: permissions.surveys.safehouse_financial,
          slug: "safehouse-financial",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Safehouse Spiritual",
          description:
              "Average score of clients who took at least one exit Safehouse Spiritual Survey. This metric takes into account Safehouse Spiritual Survey submissions and calculates the average score",
          visible: permissions.surveys.safehouse_spiritual,
          slug: "safehouse-spiritual",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Academics Anonymous Survey Score",
          description:
              "Average score of clients who took at least one exit Academics Anonymous Survey. This metric takes into account Academics Anonymous Survey submissions and calculates the average score",
          visible: permissions.surveys.acan,
          slug: "acan",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Past Participant Check In Survey Score",
          description:
              "Average score of clients who took at least one exit Past Participant Check In Survey. This metric takes into account Past Participant Check In Survey submissions and calculates the average score",
          visible: permissions.surveys.tribe_ppci,
          slug: "tribe-ppci",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Outcomes Assessment",
          description:
              "Average score of clients who took at least one Outcomes Assessment Survey. This metric takes into account Outcomes Assessment Survey submissions and calculates the average score",
          visible: permissions.surveys.tribe_ppci,
          slug: "hi-oa",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "DAST: Drug Abuse Screening Test",
          description:
              "Average score of clients who took at least one DAST: Drug Abuse Screening Test Survey. This metric takes into account DAST: Drug Abuse Screening Test Survey submissions and calculates the average score",
          visible: permissions.surveys.hi_dast,
          slug: "hi-dast",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "CAGE",
          description:
              "Average score of clients who took at least one CAGE Survey. This metric takes into account CAGE Survey submissions and calculates the average score",
          visible: permissions.surveys.hi_cage,
          slug: "hi-cage",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "AUDIT",
          description:
              "Average score of clients who took at least one AUDIT Survey. This metric takes into account AUDIT Survey submissions and calculates the average score",
          visible: permissions.surveys.hi_audit,
          slug: "hi-audit",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "MAST",
          description:
              "Average score of clients who took at least one MAST Survey. This metric takes into account MAST Survey submissions and calculates the average score",
          visible: permissions.surveys.hi_mast,
          slug: "hi-mast",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Treatment Ratings",
          description:
              "Average score of clients who took at least one Treatment Ratings Survey. This metric takes into account Treatment Ratings Survey submissions and calculates the average score",
          visible: permissions.surveys.hi_tr,
          slug: "hi-tr",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Reflecting on Parenting Support",
          description:
              "Average score of clients who took at least one Reflecting on Parenting Support Survey. This metric takes into account Reflecting on Parenting Support Survey submissions and calculates the average score",
          visible: permissions.surveys.mhrps,
          slug: "mhrps",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Recovery Capital Scale",
          description:
              "Average score of clients who took at least one Recovery Capital Scale Survey. This metric takes into account Recovery Capital Scale Survey submissions and calculates the average score",
          visible: permissions.surveys.rur_rcs,
          slug: "rur-rcs",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Wheel of Life",
          description:
              "Average score of clients who took at least one Wheel of Life Survey. This metric takes into account Wheel of Life Survey submissions and calculates the average score",
          visible: permissions.surveys.cceok_wof,
          slug: "cceok-wof",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Credit Score",
          description:
              "Average score of clients who took at least one Credit Score Survey. This metric takes into account Credit Score Survey submissions and calculates the average score",
          visible: permissions.surveys.cceok_cs,
          slug: "cceok-cs",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Initial 72-hour survey",
          description:
              "Average score of clients who took at least one Initial 72-hour Survey. This metric takes into account Initial 72-hour Survey submissions and calculates the average score",
          visible: permissions.surveys.br_i72hs,
          slug: "br-i72hs",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "TLR Alumni Survey",
          description:
              "Average score of clients who took at least one TLR Alumni Survey. This metric takes into account TLR Alumni Survey submissions and calculates the average score",
          visible: permissions.surveys.lr_tlr,
          slug: "lr-tlr",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Flourishing Measure Survey",
          description:
              "Average score of clients who took at least one Flourishing Measure Survey. This metric takes into account Flourishing Measure Survey submissions and calculates the average score",
          visible: permissions.surveys.fm,
          slug: "fm",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Alcohol Abstinence Self-Efficacy Scale (AASE) Survey",
          description:
              "Average score of clients who took at least one Alcohol Abstinence Self-Efficacy Scale (AASE) Survey. This metric takes into account Alcohol Abstinence Self-Efficacy Scale (AASE) Survey submissions and calculates the average score",
          visible: permissions.surveys.aase_20,
          slug: "aase-20",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "NEATC Patient-Alumni Survey",
          description:
              "Average score of clients who took at least one NEATC Patient-Alumni Survey. This metric takes into account NEATC Patient-Alumni Survey submissions and calculates the average score",
          visible: permissions.surveys.ark_beh_neatc,
          slug: "ark_beh_neatc",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "BEDROCK Patient-Alumni Survey",
          description:
              "Average score of clients who took at least one BEDROCK Patient-Alumni Survey. This metric takes into account BEDROCK Patient-Alumni Survey submissions and calculates the average score",
          visible: permissions.surveys.ark_beh_bedrock,
          slug: "ark_beh_bedrock",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "RCI Patient-Alumni Survey",
          description:
              "Average score of clients who took at least one RCI Patient-Alumni Survey. This metric takes into account RCI Patient-Alumni Survey submissions and calculates the average score",
          visible: permissions.surveys.ark_beh_rci,
          slug: "ark_beh_rci",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "SPRING HILL Patient-Alumni Survey",
          description:
              "Average score of clients who took at least one SPRING HILL Patient-Alumni Survey. This metric takes into account SPRING HILL Patient-Alumni Survey submissions and calculates the average score",
          visible: permissions.surveys.ark_beh_spring_hill,
          slug: "ark_beh_spring_hill",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Assessment of Recovery Capital Survey",
          description:
              "Average score of clients who took at least one Assessment of Recovery Capital Survey. This metric takes into account Assessment of Recovery Capital Survey submissions and calculates the average score",
          visible: permissions.surveys.as_rc,
          slug: "as-rc",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Perceived Stress QuestionnaireSurvey",
          description:
              "Average score of clients who took at least one Perceived Stress Questionnaire Survey. This metric takes into account Perceived Stress Questionnaire Survey submissions and calculates the average score",
          visible: permissions.surveys.fm_psq,
          slug: "fm_psq",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Case Management Survey",
          description:
              "Average score of clients who took at least one Case Management Survey. This metric takes into account Case Management Survey submissions and calculates the average score",
          visible: permissions.surveys.case_management_survey,
          slug: "case_management_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Reentry Personal Survey",
          description:
              "Average score of clients who took at least one Reentry Personal Survey. This metric takes into account Reentry Personal Survey submissions and calculates the average score",
          visible: permissions.surveys.reentry_personal_survey,
          slug: "reentry_personal_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Intake Benchmark Survey",
          description:
              "Average score of clients who took at least one Intake Benchmark Survey. This metric takes into account Intake Benchmark Survey submissions and calculates the average score",
          visible: permissions.surveys.intake_benchmark_survey,
          slug: "intake_benchmark_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "QQ - 45.2",
          description:
              "Average score of clients who took at least one Ethos QQ - 45.2 Survey. This metric takes into account Ethos QQ - 45.2 Survey submissions and calculates the average score",
          visible: permissions.surveys.qq_45_2,
          slug: "qq_45_2",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Interval Satisfaction & Progress Survey (30, 60, 90 Days, etc.)",
          description:
              "Average score of clients who took at least one Interval Satisfaction & Progress Survey (30, 60, 90 Days, etc.). This metric takes into account Interval Satisfaction & Progress Survey (30, 60, 90 Days, etc.) submissions and calculates the average score",
          visible: permissions.surveys.interval_satisfaction_progress,
          slug: "interval_satisfaction_progress",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Emotional Sustainability and Resilience Assessment",
          description:
              "Average score of clients who took at least one Emotional Sustainability and Resilience Assessment. This metric takes into account Emotional Sustainability and Resilience Assessment submissions and calculates the average score",
          visible: permissions.surveys.emotional_sustainability_resilience_assessment,
          slug: "emotional_sustainability_resilience_assessment",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "MHA Sober Living Feedback Survey",
          description:
              "Average score of clients who took at least one MHA Sober Living Feedback Survey. This metric takes into account MHA Sober Living Feedback Survey submissions and calculates the average score",
          visible: permissions.surveys.mha_sober_living_feedback_survey,
          slug: "mha_sober_living_feedback_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Toni House Exit Interview Survey",
          description:
              "Average score of clients who took at least one Toni House Exit Interview Survey. This metric takes into account Toni House Exit Interview Survey submissions and calculates the average score",
          visible: permissions.surveys.toni_house_exit_interview_survey,
          slug: "toni_house_exit_interview_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Stable Recover Evaluation",
          description:
              "Average score of clients who took at least one Stable Recover Evaluation Survey. This metric takes into account Stable Recover Evaluation Survey submissions and calculates the average score",
          visible: permissions.surveys.stable_recovery_evaluations,
          slug: "stable_recovery_evaluations",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "SriPonya Group Services Survey",
          description:
              "Average score of clients who took at least one SriPonya Group Services Survey. This metric takes into account SriPonya Group Services Survey submissions and calculates the average score",
          visible: permissions.surveys.pirs_group_services,
          slug: "pirs_group_services",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Fairview Housing Resident Satisfaction Survey",
          description:
              "Average score of clients who took at least one Fairview Housing Resident Satisfaction Survey. This metric takes into account Fairview Housing Resident Satisfaction Survey submissions and calculates the average score",
          visible: permissions.surveys.fairview_housing_resident_satisfaction_survey,
          slug: "fairview_housing_resident_satisfaction_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Family Recovery Course - Baseline Survey",
          description:
              "Average score of clients who took at least one Family Recovery Course Baseline Survey. This metric takes into account Baseline Survey submissions and calculates the average total score.",
          visible: permissions.surveys.frc_baseline_survey,
          slug: "frc_baseline_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Family Recovery Course - Follow Up Survey",
          description:
              "Average score of clients who took at least one Family Recovery Course Follow Up Survey. This metric takes into account Follow Up Survey submissions and calculates the average total score.",
          visible: permissions.surveys.frc_follow_up_survey,
          slug: "frc_follow_up_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "Family Recovery Course - Final Survey",
          description:
              "Average score of clients who took at least one Family Recovery Course Final Survey. This metric takes into account Final Survey submissions and calculates the average total score.",
          visible: permissions.surveys.frc_final_survey,
          slug: "frc_final_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "HOPE HOUSE PATHWAYS PROGRAM",
          description:
              "Average score of clients who took at least one HOPE HOUSE PATHWAYS PROGRAM Survey. This metric takes into account HOPE HOUSE PATHWAYS PROGRAM Survey submissions and calculates the average score",
          visible: permissions.surveys.hope_house_pathways_program,
          slug: "hope_house_pathways_program",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "PCL-5",
          description:
              "Average score of clients who took at least one PCL-5 Survey. This metric takes into account PCL-5 Survey submissions and calculates the average score",
          visible: permissions.surveys.pcl5,
          slug: "pcl5",
        },
        ...[{
          name: 'Social Support',
          slug: 'ss'
        }, {
          name: 'Problem Solving',
          slug: 'ps'
        }, {
          name: 'Depression',
          slug: 'd'
        }, {
          name: 'Personal Care',
          slug: 'pc'
        }, {
          name: 'Mobilizing Resources',
          slug: 'mr'
        }, {
          name: 'Role Satisfaction',
          slug: 'rs'
        }, {
          name: 'Parent/Child Interaction',
          slug: 'pci'
        }, {
          name: 'Home Environment',
          slug: 'he'
        }, {
          name: 'Parenting Efficacy',
          slug: 'pe'
        }].map((survey) => {
          return {
            endpoint: "average_score_in_general_per_month",
            title: `Healthy Families Parenting Inventory - ${survey.name} Survey`,
            description: `Average score of clients who took at least one ${survey.name} Survey. This metric takes into account ${survey.name} Survey submissions and calculates the average score`,
            visible: permissions.surveys[`cceok_hfpi_${survey.slug}`],
            slug: `cceok-hfpi-${survey.slug}`,
          };
        }),
        {
          endpoint: 'average_score_in_general_per_month',
          title: "25 - Item Resilience Scale Survey",
          description:
              "Average score of clients who took at least one 25 - Item Resilience Scale Survey. This metric takes into account 25 - Item Resilience Scale Survey submissions and calculates the average score",
          visible: permissions.surveys.rbh_rs,
          slug: "rbh-rs",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "The Trait Hope Scale Survey",
          description:
              "Average score of clients who took at least one The Trait Hope Scale Survey. This metric takes into account The Trait Hope Scale Survey submissions and calculates the average score",
          visible: permissions.surveys.rbh_ths,
          slug: "rbh-ths",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Multidimensional Scale of Perceived Social Support",
          description:
              "Average score of clients who took at least one Multidimensional Scale of Perceived Social Support Survey. This metric takes into account Multidimensional Scale of Perceived Social Support Survey submissions and calculates the average score",
          visible: permissions.surveys.rbh_msp,
          slug: "rbh-msp",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Trauma Symptom Checklist",
          description:
              "Average score of clients who took at least one Trauma Symptom Checklist Survey. This metric takes into account Trauma Symptom Checklist Survey submissions and calculates the average score",
          visible: permissions.surveys.rbh_tsc,
          slug: "rbh-tsc",
        },
        ...[{
          name: 'Residential Treatment',
          slug: 'rt'
        }, {
          name: 'Detox Treatment',
          slug: 'dt'
        }, {
          name: 'Behavioral Wellness Outpatient Services',
          slug: 'bwos'
        }, {
          name: 'Recovery Housing',
          slug: 'rh'
        }, {
          name: 'New Dawn Family Healing',
          slug: 'ndfh'
        }].map((survey) => {
          return {
            endpoint: "average_score_in_general_per_month",
            title: `Member Satisfaction Survey - ${survey.name} Survey`,
            description: `Average score of clients who took at least one Member Satisfaction Survey - ${survey.name} Survey. This metric takes into account Member Satisfaction Survey - ${survey.name} Survey submissions and calculates the average score`,
            visible: permissions.surveys[`mss_${survey.slug}`],
            slug: `mss_${survey.slug}`,
          };
        }),
        {
          endpoint: 'average_score_in_general_per_month',
          title: "RC36",
          description:
            "Average score of clients who took at least one RC36 Survey. This metric takes into account RC36 Survey submissions and calculates the average score",
          visible: permissions.surveys.rc_36,
          slug: "rc_36",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "30 Days - Admission Survey",
          description:
            "Average score of clients who took at least one 30 Days - Admission Survey. This metric takes into account 30 Days - Admission Survey submissions and calculates the average score",
          visible: permissions.surveys.as_rpwv,
          slug: "as_rpwv",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "30 Days - Discharge Survey",
          description:
            "Average score of clients who took at least one 30 Days - Discharge Survey. This metric takes into account 30 Days - Discharge Survey submissions and calculates the average score",
          visible: permissions.surveys.ad_rpwv,
          slug: "ad_rpwv",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Peer Session Entry Form",
          description:
            "Average score of clients who took at least one Peer Session Entry Form Survey. This metric takes into account Peer Session Entry Form Survey submissions and calculates the average score",
          visible: permissions.surveys.docs_recovery,
          slug: "docs_recovery",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Legal Survey",
          description:
            "Average score of clients who took at least one Legal Survey. This metric takes into account Legal Survey submissions and calculates the average score",
          visible: permissions.surveys.legal_survey,
          slug: "legal_survey",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Threshold Recovery Survey Transportation Log ",
          description:
            "Average score of clients who took at least one Threshold Recovery Survey Transportation Log. This metric takes into account Threshold Recovery Survey Transportation Log submissions and calculates the average score",
          visible: permissions.surveys.recovery_survey_transportation_log,
          slug: "recovery_survey_transportation_log",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Participant Satisfaction",
          description:
            "Average score of clients who took at least one Participant Satisfaction. This metric takes into account Participant Satisfaction submissions and calculates the average score",
          visible: permissions.surveys.participant_satisfaction_survey,
          slug: "participant_satisfaction_survey",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Client Satisfaction Survey",
          description:
            "Average score of clients who took at least one Client Satisfaction Survey. This metric takes into account Client Satisfaction Survey submissions and calculates the average score",
          visible: permissions.surveys.client_satisfaction,
          slug: "client_satisfaction",
        },
        {
          endpoint: "average_score_in_general",
          title: "ACE Extension",
          description:
            "Average score of clients who took at least one ACE Extension. This metric takes into account ACE Extension submissions and calculates the average score",
          visible: permissions.surveys.ace_extension,
          slug: "ace_extension",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "PPM Group Participation Session",
          description:
            "Average score of clients who took at least one PPM Group Participation Session. This metric takes into account PPM Group Participation Session submissions and calculates the average score",
          visible: permissions.surveys.ppm_group_participation_session,
          slug: "ppm_group_participation_session",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Exit Interview Questionnaire",
          description:
            "Average score of clients who took at least one Exit Interview Questionnaire. This metric takes into account Exit Interview Questionnaire submissions and calculates the average score",
          visible: permissions.surveys.exit_interview_questionnaire,
          slug: "exit_interview_questionnaire",
        },

        {
          endpoint: 'average_score_in_general_per_month',
          title: "Ethos Discharge Survey",
          description:
            "Average score of clients who took at least one Ethos Discharge Survey. This metric takes into account Ethos Discharge Survey submissions and calculates the average score",
          visible: permissions.surveys.ethos_discharge_survey,
          slug: "ethos_discharge_survey",
        },
        {
          endpoint: "average_score_in_general_per_month",
          title: "The Adult Hope Scale",
          description:
            "Average score of clients who took at least one The Adult Hope Scale survey. This metric takes into account The Adult Hope Scale submissions and calculates the average score",
          visible: permissions.surveys.adult_hope_scale,
          slug: "adult_hope_scale",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "RECCAP Survey",
          description:
            "Average score of clients who took at least one RECCAP Survey. This metric takes into account RECCAP Survey submissions and calculates the average score",
          visible: permissions.surveys.reccap,
          slug: "reccap",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Transportation Driver Survey",
          description:
            "Average score of clients who took at least one Transportation Driver Survey. This metric takes into account Transportation Driver Survey submissions and calculates the average score",
          visible: permissions.surveys.transportation_driver_survey,
          slug: "transportation_driver_survey",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Phase 3 Checkin",
          description:
            "Average score of clients who took at least one Phase 3 Checkin Survey. This metric takes into account Phase 3 Checkin Survey submissions and calculates the average score",
          visible: permissions.surveys.phase_3_checkin,
          slug: "phase_3_checkin",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Weekly Checkin",
          description:
            "Average score of clients who took at least one Weekly Checkin Survey. This metric takes into account Weekly Checkin Survey submissions and calculates the average score",
          visible: permissions.surveys.weekly_checkin,
          slug: "weekly_checkin",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Career Coach",
          description:
            "Average score of clients who took at least one Career Coach Survey. This metric takes into account Career Coach Survey submissions and calculates the average score",
          visible: permissions.surveys.career_coach,
          slug: "career_coach",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Threshold Recovery Capital: Initial Assessment",
          description:
            "Average score of clients who took at least one Threshold Recovery Capital: Initial Assessment Survey. This metric takes into account Threshold Recovery Capital: Initial Assessment Survey submissions and calculates the average score",
          visible: permissions.surveys.threshold_recovery_capital,
          slug: "threshold_recovery_capital",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Participant Satisfaction",
          description:
            "Average score of clients who took at least one Participant Satisfaction Survey. This metric takes into account Participant Satisfaction Survey submissions and calculates the average score",
          visible: permissions.surveys.participant_satisfaction,
          slug: "participant_satisfaction",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Peer Support Session",
          description:
            "Average score of clients who took at least one Peer Support Session Survey. This metric takes into account Peer Support Session Survey submissions and calculates the average score",
          visible: permissions.surveys.peer_support_session,
          slug: "peer_support_session",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Discharge Survey",
          description:
            "Average score of clients who took at least one Discharge Survey. This metric takes into account Discharge Survey submissions and calculates the average score",
          visible: permissions.surveys.discharge_survey,
          slug: "discharge_survey",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Would You Recommend Us?",
          description:
            "Average score of clients who took at least one Would You Recommend Us Survey. This metric takes into account Would You Recommend Us Survey submissions and calculates the average score",
          visible: permissions.surveys.would_you_recommend_us,
          slug: "would_you_recommend_us",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Truly Motivational Transitional Living",
          description:
            "Average score of clients who took at least one Truly Motivational Transitional Living Survey. This metric takes into account Truly Motivational Transitional Living Survey submissions and calculates the average score",
          visible: permissions.surveys.truly_motivational_transitional_living,
          slug: "truly_motivational_transitional_living",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "RCI - 36",
          description:
            "Average score of clients who took at least one RCI - 36 Survey. This metric takes into account RCI - 36 Survey submissions and calculates the average score",
          visible: permissions.surveys.rci_36,
          slug: "rci_36",
        },
        {
          endpoint: 'average_score_in_general_per_month',
          title: "Donation Application",
          description:
            "Average score of clients who took at least one Donation Application Survey. This metric takes into account Donation Application Survey submissions and calculates the average score",
          visible: permissions.surveys.donation_application,
          slug: "donation_application",
        }
      ],
      percentChangePerMonthMetrics: [
        {
          endpoint: "average_percent_change_per_month",
          title: "Catholic Charities: Stability Factors",
          visible: permissions.surveys.mhsf,
          slug: "mhsf",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Admission Program Evaluation",
          visible: permissions.surveys.admission_program_evaluation,
          slug: "admission_program_evaluation",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Ethos Discharge Survey",
          visible: permissions.surveys.ethos_discharge_survey,
          slug: "ethos_discharge_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "The Adult Hope Scale",
          visible: permissions.surveys.adult_hope_scale,
          slug: "adult_hope_scale",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Discharge Program Evaluation",
          visible: permissions.surveys.discharge_program_evaluation,
          slug: "discharge_program_evaluation",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Catholic Charities: Supplemental Stability Factors",
          visible: permissions.surveys.mhssf,
          slug: "mhssf",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Catholic Charities: Pregnancy / Parenting Factors",
          visible: permissions.surveys.mhppf,
          slug: "mhppf",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Personal Wellness Assessment",
          visible: permissions.surveys.pwa_8,
          slug: "pwa-8",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In DASS21",
          description:
              "Percent increase/decrease in DASS21 total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the DASS21 at least twice. This metric takes into account ALL DASS21 survey submissions and calculates the average DASS21 percent change between EVERY DASS21 survey submission.",
          visible: permissions.surveys.dass_21,
          slug: "dass-21",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Exit Survey",
          description:
              "Percent increase/decrease in Exit Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Exit Survey at least twice. This metric takes into account ALL Exit Survey survey submissions and calculates the average Exit Survey percent change between EVERY Exit Survey submission.",
          visible: permissions.surveys.bayshore_exit_survey,
          slug: "bayshore-exit-survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In CISS",
          description:
              "Percent increase/decrease in CISS total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the CISS at least twice. This metric takes into account ALL CISS survey submissions and calculates the average CISS percent change between EVERY CISS survey submission.",
          visible: permissions.surveys.ciss,
          slug: "ciss",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In PCL",
          description:
              "Percent increase/decrease in PCL total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the PCL at least twice. This metric takes into account ALL PCL survey submissions and calculates the average PCL percent change between EVERY PCL survey submission.",
          visible: permissions.surveys.pcl,
          slug: "pclc",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In PHQ",
          description:
              "Percent increase/decrease in PHQ total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the PHQ at least twice. This metric takes into account ALL PHQ survey submissions and calculates the average PHQ percent change between EVERY PHQ survey submission.",
          visible: permissions.surveys.phq,
          slug: "phq9",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In GAD",
          description:
              "Percent increase/decrease in GAD total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the GAD at least twice. This metric takes into account ALL GAD survey submissions and calculates the average GAD percent change between EVERY GAD survey submission.",
          visible: permissions.surveys.gad,
          slug: "gad7",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In DLA",
          description:
              "Percent increase/decrease in DLA total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the DLA at least twice. This metric takes into account ALL DLA survey submissions and calculates the average DLA percent change between EVERY DLA survey submission.",
          visible: permissions.surveys.dla,
          slug: "dla-20",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in ACEs",
          description:
              "Percent increase/decrease in ACEs total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the ACEs at least twice. This metric takes into account ALL ACEs survey submissions and calculates the average ACEs percent change between EVERY ACEs survey submission.",
          visible: permissions.surveys.ace,
          slug: "ace",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Infant Daily Measure",
          description:
              "Percent increase/decrease in Infant Daily Measure total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Infant Daily Measure at least twice. This metric takes into account ALL Infant Daily Measure survey submissions and calculates the average Infant Daily Measure percent change between EVERY Infant Daily Measure survey submission.",
          visible: permissions.surveys.mhidm,
          slug: "mhidm",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse Sobriety",
          description:
              "Percent increase/decrease in Safehouse Sobriety total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse Sobriety at least twice. This metric takes into account ALL Safehouse Sobriety survey submissions and calculates the average Safehouse Sobriety percent change between EVERY Safehouse Sobriety survey submission.",
          visible: permissions.surveys.safehouse_sobriety,
          slug: "safehouse-sobriety",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse 12 Step",
          description:
              "Percent increase/decrease in Safehouse 12 Step total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse 12 Step(OLD) at least twice. This metric takes into account ALL Safehouse 12 Step survey(OLD) submissions and calculates the average Safehouse 12 Step percent change between EVERY Safehouse 12 Step survey submission.",
          visible: permissions.surveys.safehouse_twelve_step_other,
          slug: "safehouse-12-step-other",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse 12 Step(OLD)",
          description:
              "Percent increase/decrease in Safehouse 12 Step(OLD) total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse 12 Step at least twice. This metric takes into account ALL Safehouse 12 Step survey submissions and calculates the average Safehouse 12 Step percent change between EVERY Safehouse 12 Step survey submission.",
          visible: permissions.surveys.safehouse_twelve_step,
          slug: "safehouse-12-step",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse Community",
          description:
              "Percent increase/decrease in Safehouse Community total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse Community at least twice. This metric takes into account ALL Safehouse Community survey submissions and calculates the average Safehouse Sobriety Community percent change between EVERY Safehouse Sobriety Community submission.",
          visible: permissions.surveys.safehouse_community,
          slug: "safehouse-community",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse Education",
          description:
              "Percent increase/decrease in Safehouse Education total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse Education at least twice. This metric takes into account ALL Safehouse Education survey submissions and calculates the average Safehouse Education percent change between EVERY Safehouse Education survey submission.",
          visible: permissions.surveys.safehouse_education,
          slug: "safehouse-education",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse Financial",
          description:
              "Percent increase/decrease in Safehouse Financial total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse Financial at least twice. This metric takes into account ALL Safehouse Financial survey submissions and calculates the average Safehouse Financial percent change between EVERY Safehouse Financial survey submission.",
          visible: permissions.surveys.safehouse_financial,
          slug: "safehouse-financial",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change In Safehouse Spiritual",
          description:
              "Percent increase/decrease in Safehouse Spiritual total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Safehouse Spiritual at least twice. This metric takes into account ALL Safehouse Spiritual survey submissions and calculates the average Safehouse Spiritual percent change between EVERY Safehouse Spiritual survey submission.",
          visible: permissions.surveys.safehouse_spiritual,
          slug: "safehouse-spiritual",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Academics Anonymous",
          description:
              "Percent increase/decrease in Academics Anonymous total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Academics Anonymous at least twice. This metric takes into account ALL Academics Anonymous survey submissions and calculates the average Academics Anonymous percent change between EVERY Academics Anonymous survey submission.",
          visible: permissions.surveys.acan,
          slug: "acan",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Past Participant Check In",
          description:
              "Percent increase/decrease in Past Participant Check In total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Past Participant Check In at least twice. This metric takes into account ALL Past Participant Check In survey submissions and calculates the average Past Participant Check In percent change between EVERY Past Participant Check In survey submission.",
          visible: permissions.surveys.tribe_ppci,
          slug: "tribe-ppci",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Outcomes Assessment",
          description:
              "Percent increase/decrease in Outcomes Assessment total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Outcomes Assessment at least twice. This metric takes into account ALL Outcomes Assessment survey submissions and calculates the average Outcomes Assessment percent change between EVERY Outcomes Assessment survey submission.",
          visible: permissions.surveys.hi_oa,
          slug: "hi-oa",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in DAST: Drug Abuse Screening Test",
          description:
              "Percent increase/decrease in DAST: Drug Abuse Screening Test total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the DAST: Drug Abuse Screening Test at least twice. This metric takes into account ALL DAST: Drug Abuse Screening Test survey submissions and calculates the average DAST: Drug Abuse Screening Test percent change between EVERY DAST: Drug Abuse Screening Test survey submission.",
          visible: permissions.surveys.hi_dast,
          slug: "hi-dast",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in CAGE",
          description:
              "Percent increase/decrease in CAGE total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the CAGE survey at least twice. This metric takes into account ALL CAGE survey submissions and calculates the average CAGE survey percent change between EVERY CAGE survey submission.",
          visible: permissions.surveys.hi_cage,
          slug: "hi-cage",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in AUDIT",
          description:
              "Percent increase/decrease in AUDIT total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the AUDIT survey at least twice. This metric takes into account ALL AUDIT survey submissions and calculates the average AUDIT survey percent change between EVERY AUDIT survey submission.",
          visible: permissions.surveys.hi_audit,
          slug: "hi-audit",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in MAST",
          description:
              "Percent increase/decrease in MAST total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the MAST Survey at least twice. This metric takes into account ALL MAST survey submissions and calculates the average MAST percent change between EVERY MAST survey submission.",
          visible: permissions.surveys.hi_mast,
          slug: "hi-mast",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Treatment Ratings",
          description:
              "Percent increase/decrease in Treatment Ratings total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Treatment Ratings at least twice. This metric takes into account ALL Treatment Ratings survey submissions and calculates the average Treatment Ratings percent change between EVERY Treatment Ratings survey submission.",
          visible: permissions.surveys.hi_tr,
          slug: "hi-tr",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Reflecting on Parenting Support",
          description:
              "Percent increase/decrease in Reflecting on Parenting Support total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Reflecting on Parenting Support at least twice. This metric takes into account ALL Reflecting on Parenting Support survey submissions and calculates the average Reflecting on Parenting Support percent change between EVERY Reflecting on Parenting Support survey submission.",
          visible: permissions.surveys.mhrps,
          slug: "mhrps",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Recovery Capital Scale",
          description:
              "Percent increase/decrease in Recovery Capital Scale total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Recovery Capital Scale survey at least twice. This metric takes into account ALL Recovery Capital Scale survey submissions and calculates the average Recovery Capital Scale percent change between EVERY Recovery Capital Scale survey submission.",
          visible: permissions.surveys.rur_rcs,
          slug: "rur-rcs",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Wheel of Life",
          description:
              "Percent increase/decrease in Wheel of Life total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Wheel of Life survey at least twice. This metric takes into account ALL Wheel of Life survey submissions and calculates the average Wheel of Life percent change between EVERY Wheel of Life survey submission.",
          visible: permissions.surveys.cceok_wof,
          slug: "cceok-wof",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Initial 72-hour Survey",
          description:
              "Percent increase/decrease in Initial 72-hour Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Initial 72-hour Survey at least twice. This metric takes into account ALL Initial 72-hour Survey submissions and calculates the average Initial 72-hour Survey percent change between EVERY Initial 72-hour Survey submission.",
          visible: permissions.surveys.br_i72hs,
          slug: "br-i72hs",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in TLR Alumni Survey",
          description:
              "Percent increase/decrease in TLR Alumni Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the TLR Alumni Survey at least twice. This metric takes into account ALL TLR Alumni Survey submissions and calculates the average TLR Alumni Survey percent change between EVERY TLR Alumni Survey submission.",
          visible: permissions.surveys.lr_tlr,
          slug: "lr-tlr",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Flourishing Measure Survey",
          description:
              "Percent increase/decrease in Flourishing Measure Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Flourishing Measure Survey at least twice. This metric takes into account ALL Flourishing Measure Survey submissions and calculates the average Flourishing Measure Survey percent change between EVERY Flourishing Measure Survey submission.",
          visible: permissions.surveys.fm,
          slug: "fm",
        },
        {
          endpoint: "average_percent_change_per_month",
          title:
              "Percent Change in Alcohol Abstinence Self-Efficacy Scale (AASE) Survey",
          description:
              "Percent increase/decrease in Alcohol Abstinence Self-Efficacy Scale (AASE) Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Alcohol Abstinence Self-Efficacy Scale (AASE) Survey at least twice. This metric takes into account ALL Alcohol Abstinence Self-Efficacy Scale (AASE) Survey submissions and calculates the average Alcohol Abstinence Self-Efficacy Scale (AASE) Survey percent change between EVERY Alcohol Abstinence Self-Efficacy Scale (AASE) Survey submission.",
          visible: permissions.surveys.aase_20,
          slug: "aase-20",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in NEATC Patient-Alumni Survey",
          description:
              "Percent increase/decrease in NEATC Patient-Alumni Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the NEATC Patient-Alumni Survey at least twice. This metric takes into account ALL NEATC Patient-Alumni Survey submissions and calculates the average NEATC Patient-Alumni Survey percent change between EVERY NEATC Patient-Alumni Survey submission.",
          visible: permissions.surveys.ark_beh_neatc,
          slug: "ark_beh_neatc",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in BEDROCK Patient-Alumni Survey",
          description:
              "Percent increase/decrease in BEDROCK Patient-Alumni Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the BEDROCK Patient-Alumni Survey at least twice. This metric takes into account ALL BEDROCK Patient-Alumni Survey submissions and calculates the average BEDROCK Patient-Alumni Survey percent change between EVERY BEDROCK Patient-Alumni Survey submission.",
          visible: permissions.surveys.ark_beh_bedrock,
          slug: "ark_beh_bedrock",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in RCI Patient-Alumni Survey",
          description:
              "Percent increase/decrease in RCI Patient-Alumni Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the RCI Patient-Alumni Survey at least twice. This metric takes into account ALL RCI Patient-Alumni Survey submissions and calculates the average RCI Patient-Alumni Survey percent change between EVERY RCI Patient-Alumni Survey submission.",
          visible: permissions.surveys.ark_beh_rci,
          slug: "ark_beh_rci",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in SPRING HILL Patient-Alumni Survey",
          description:
              "Percent increase/decrease in SPRING HILL Patient-Alumni Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the SPRING HILL Patient-Alumni Survey at least twice. This metric takes into account ALL SPRING HILL Patient-Alumni Survey submissions and calculates the average SPRING HILL Patient-Alumni Survey percent change between EVERY SPRING HILL Patient-Alumni Survey submission.",
          visible: permissions.surveys.ark_beh_spring_hill,
          slug: "ark_beh_spring_hill",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Assessment of Recovery Capital Survey",
          description:
              "Percent increase/decrease in Assessment of Recovery Capital Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Assessment of Recovery Capital Survey at least twice. This metric takes into account ALL Assessment of Recovery Capital Survey submissions and calculates the average Assessment of Recovery Capital Survey percent change between EVERY Assessment of Recovery Capital Survey submission.",
          visible: permissions.surveys.as_rc,
          slug: "as-rc",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Percent Change in Perceived Stress Questionnaire Survey",
          description:
              "Percent increase/decrease in Perceived Stress Questionnaire Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Perceived Stress Questionnaire Survey at least twice. This metric takes into account ALL Perceived Stress Questionnaire Survey submissions and calculates the average Perceived Stress Questionnaire Survey percent change between EVERY Perceived Stress Questionnaire Survey submission.",
          visible: permissions.surveys.fm_psq,
          slug: "fm_psq",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Intake Benchmark Survey",
          visible: permissions.surveys.intake_benchmark_survey,
          slug: "intake_benchmark_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "QQ - 45.2",
          visible: permissions.surveys.qq_45_2,
          slug: "qq_45_2",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Interval Satisfaction & Progress Survey (30, 60, 90 Days, etc.)",
          visible: permissions.surveys.interval_satisfaction_progress,
          slug: "interval_satisfaction_progress",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Emotional Sustainability and Resilience Assessment",
          visible: permissions.surveys.emotional_sustainability_resilience_assessment,
          slug: "emotional_sustainability_resilience_assessment",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "MHA Sober Living Feedback Survey",
          visible: permissions.surveys.mha_sober_living_feedback_survey,
          slug: "mha_sober_living_feedback_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Toni House Exit Interview Survey",
          visible: permissions.surveys.toni_house_exit_interview_survey,
          slug: "toni_house_exit_interview_survey",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Stable Recovery Evaluations",
          visible: permissions.surveys.stable_recovery_evaluations,
          slug: "stable_recovery_evaluations",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "SriPonya Group Services Survey",
          visible: permissions.surveys.pirs_group_services,
          slug: "pirs_group_services",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Fairview Housing Resident Satisfaction Survey",
          visible: permissions.surveys.fairview_housing_resident_satisfaction_survey,
          slug: "fairview_housing_resident_satisfaction_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Family Recovery Course - Baseline Survey",
          visible: permissions.surveys.frc_baseline_survey,
          slug: "frc_baseline_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Family Recovery Course - Follow Up Survey",
          visible: permissions.surveys.frc_follow_up_survey,
          slug: "frc_follow_up_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Family Recovery Course - Final Survey",
          visible: permissions.surveys.frc_final_survey,
          slug: "frc_final_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "HOPE HOUSE PATHWAYS PROGRAM",
          description:
            "Percent increase/decrease in HOPE HOUSE PATHWAYS PROGRAM Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the HOPE HOUSE PATHWAYS PROGRAM Survey at least twice. This metric takes into account ALL HOPE HOUSE PATHWAYS PROGRAM Survey submissions and calculates the average HOPE HOUSE PATHWAYS PROGRAM Survey percent change between EVERY HOPE HOUSE PATHWAYS PROGRAM Survey submission.",
          visible: permissions.surveys.hope_house_pathways_program,
          slug: "hope_house_pathways_program",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "PCL-5",
          description:
            "Percent increase/decrease in PCL-5 total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the PCL-5 at least twice. This metric takes into account ALL PCL-5 survey submissions and calculates the average PCL-5 percent change between EVERY PCL-5 survey submission.",
          visible: permissions.surveys.pcl5,
          slug: "pcl5",
        },
        ...[{
          name: 'Social Support',
          slug: 'ss'
        }, {
          name: 'Problem Solving',
          slug: 'ps'
        }, {
          name: 'Depression',
          slug: 'd'
        }, {
          name: 'Personal Care',
          slug: 'pc'
        }, {
          name: 'Mobilizing Resources',
          slug: 'mr'
        }, {
          name: 'Role Satisfaction',
          slug: 'rs'
        }, {
          name: 'Parent/Child Interaction',
          slug: 'pci'
        }, {
          name: 'Home Environment',
          slug: 'he'
        }, {
          name: 'Parenting Efficacy',
          slug: 'pe'
        }].map((survey) => {
          return {
            endpoint: "average_percent_change_per_month",
            title: `Healthy Families Parenting Inventory - ${survey.name} Survey`,
            description: `Percent increase/decrease in ${survey.name} Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the ${survey.name} Survey at least twice. This metric takes into account ALL ${survey.name} Survey submissions and calculates the average ${survey.name} Survey score between EVERY ${survey.name} Survey submission.`,
            visible: permissions.surveys[`cceok_hfpi_${survey.slug}`],
            slug: `cceok-hfpi-${survey.slug}`,
          };
        }),
        ...[{
          name: 'Residential Treatment',
          slug: 'rt'
        }, {
          name: 'Detox Treatment',
          slug: 'dt'
        }, {
          name: 'Behavioral Wellness Outpatient Services',
          slug: 'bwos'
        }, {
          name: 'Recovery Housing',
          slug: 'rh'
        }, {
          name: 'New Dawn Family Healing',
          slug: 'ndfh'
        }].map((survey) => {
          return {
            endpoint: "average_percent_change_per_month",
            title: `Member Satisfaction Survey - ${survey.name} Survey`,
            description: `Percent increase/decrease in Member Satisfaction Survey - ${survey.name} Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Member Satisfaction Survey - ${survey.name} Survey at least twice. This metric takes into account ALL Member Satisfaction Survey - ${survey.name} Survey submissions and calculates the average Member Satisfaction Survey - ${survey.name} Survey score between EVERY Member Satisfaction Survey - ${survey.name} Survey submission.`,
            visible: permissions.surveys[`mss_${survey.slug}`],
            slug: `mss_${survey.slug}`,
          };
        }),
        {
          endpoint: "average_percent_change_per_month",
          title: "RC36 Survey",
          description:
            "Percent increase/decrease in RC36 Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the RC36 Survey at least twice. This metric takes into account ALL RC36 Survey submissions and calculates the average RC36 Survey percent change between EVERY RC36 Survey submission.",
          visible: permissions.surveys.rc_36,
          slug: "rc_36",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "30 Days - Admission Survey",
          description:
            "Percent increase/decrease in 30 Days - Admission Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the 30 Days - Admission Survey at least twice. This metric takes into account ALL 30 Days - Admission Survey submissions and calculates the average 30 Days - Admission Survey percent change between EVERY 30 Days - Admission Survey submission.",
          visible: permissions.surveys.as_rpwv,
          slug: "as_rpwv",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Participant Satisfaction",
          description:
            "Percent increase/decrease in Participant Satisfaction total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Participant Satisfaction at least twice. This metric takes into account ALL Participant Satisfaction submissions and calculates the average Participant Satisfaction percent change between EVERY Participant Satisfaction submission.",
          visible: permissions.surveys.participant_satisfaction_survey,
          slug: "participant_satisfaction_survey",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Client Satisfaction Survey",
          description:
            "Percent increase/decrease in Client Satisfaction Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Client Satisfaction Survey at least twice. This metric takes into account ALL Client Satisfaction Survey submissions and calculates the average Client Satisfaction Survey percent change between EVERY Client Satisfaction Survey submission.",
          visible: permissions.surveys.client_satisfaction,
          slug: "client_satisfaction"
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "ACE Extension",
          description:
            "Percent increase/decrease in ACE Extension total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the ACE Extension at least twice. This metric takes into account ALL ACE Extension submissions and calculates the average ACE Extension percent change between EVERY ACE Extension submission.",
          visible: permissions.surveys.ace_extension,
          slug: "ace_extension",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "Exit Interview Questionnaire",
          description:
            "Percent increase/decrease in Exit Interview Questionnaire total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Exit Interview Questionnaire at least twice. This metric takes into account ALL Exit Interview Questionnaire submissions and calculates the average Exit Interview Questionnaire percent change between EVERY Exit Interview Questionnaire submission.",
          visible: permissions.surveys.exit_interview_questionnaire,
          slug: "exit_interview_questionnaire",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "RECCAP Survey",
          description:
            "Percent increase/decrease in RECCAP Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the RECCAP Survey at least twice. This metric takes into account ALL RECCAP Survey submissions and calculates the average RECCAP Survey percent change between EVERY RECCAP Survey submission.",
          visible: permissions.surveys.reccap,
          slug: "reccap",
        },
        {
          endpoint: "average_percent_change_per_month",
          title: "30 Days - Discharge Survey",
          description:
            "Percent increase/decrease in 30 Days - Discharge Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the 30 Days - Discharge Survey at least twice. This metric takes into account ALL 30 Days - Discharge Survey submissions and calculates the average 30 Days - Discharge Survey percent change between EVERY 30 Days - Discharge Survey submission.",
          visible: permissions.surveys.ad_rpwv,
          slug: "ad_rpwv",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Peer Session Entry Form",
          description:
            "Percent increase/decrease in Peer Session Entry Form Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Peer Session Entry Form Survey at least twice. This metric takes into account ALL Peer Session Entry Form Survey submissions and calculates the average Peer Session Entry Form Survey percent change between EVERY Peer Session Entry Form Survey submission.",
          visible: permissions.surveys.docs_recovery,
          slug: "docs_recovery",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Case Management Survey",
          description:
            "Percent increase/decrease in Case Management Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Case Management Survey at least twice. This metric takes into account ALL Case Management Survey submissions and calculates the average Case Management Survey percent change between EVERY Case Management Survey submission.",
          visible: permissions.surveys.case_management_survey,
          slug: "case_management_survey",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Reentry Personal Survey",
          description:
            "Percent increase/decrease in Reentry Personal Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Reentry Personal Survey at least twice. This metric takes into account ALL Reentry Personal Survey submissions and calculates the average Reentry Personal Survey percent change between EVERY Reentry Personal Survey submission.",
          visible: permissions.surveys.reentry_personal_survey,
          slug: "reentry_personal_survey",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Legal Survey",
          description:
            "Percent increase/decrease in Legal Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Legal Survey at least twice. This metric takes into account ALL Legal Survey submissions and calculates the average Legal Survey percent change between EVERY Legal Survey submission.",
          visible: permissions.surveys.legal_survey,
          slug: "legal_survey",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Threshold Recovery Survey Transportation Log",
          description:
            "Percent increase/decrease in Threshold Recovery Survey Transportation Log total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Threshold Recovery Survey Transportation Log at least twice. This metric takes into account ALL Threshold Recovery Survey Transportation Log submissions and calculates the average Threshold Recovery Survey Transportation Log percent change between EVERY Threshold Recovery Survey Transportation Log submission.",
          visible: permissions.surveys.recovery_survey_transportation_log,
          slug: "recovery_survey_transportation_log",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Transportation Driver Survey",
          description:
            "Percent increase/decrease in Transportation Driver Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Transportation Driver Survey at least twice. This metric takes into account ALL Transportation Driver Survey submissions and calculates the average Transportation Driver Survey percent change between EVERY Transportation Driver Survey submission.",
          visible: permissions.surveys.transportation_driver_survey,
          slug: "transportation_driver_survey",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Phase 3 Checkin",
          description:
            "Percent increase/decrease in Phase 3 Checkin Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Phase 3 Checkin Survey at least twice. This metric takes into account ALL Phase 3 Checkin Survey submissions and calculates the average Phase 3 Checkin Survey percent change between EVERY Phase 3 Checkin Survey submission.",
          visible: permissions.surveys.phase_3_checkin,
          slug: "phase_3_checkin",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Weekly Checkin",
          description:
            "Percent increase/decrease in Weekly Checkin Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Weekly Checkin Survey at least twice. This metric takes into account ALL Weekly Checkin Survey submissions and calculates the average Weekly Checkin Survey percent change between EVERY Weekly Checkin Survey submission.",
          visible: permissions.surveys.weekly_checkin,
          slug: "weekly_checkin",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Career Coach",
          description:
            "Percent increase/decrease in Career Coach Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Career Coach Survey at least twice. This metric takes into account ALL Career Coach Survey submissions and calculates the average Career Coach Survey percent change between EVERY Career Survey submission.",
          visible: permissions.surveys.career_coach,
          slug: "career_coach",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Threshold Recovery Capital: Initial Assessment",
          description:
            "Percent increase/decrease in Threshold Recovery Capital: Initial Assessment Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Threshold Recovery Capital: Initial Assessment Survey at least twice. This metric takes into account ALL Threshold Recovery Capital: Initial Assessment Survey submissions and calculates the average Threshold Recovery Capital: Initial Assessment Survey percent change between EVERY Career Survey submission.",
          visible: permissions.surveys.threshold_recovery_capital,
          slug: "threshold_recovery_capital",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Participant Satisfaction",
          description:
            "Percent increase/decrease in Participant Satisfaction Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Participant Satisfaction Survey at least twice. This metric takes into account ALL Participant Satisfaction Survey submissions and calculates the average Participant Satisfaction Survey percent change between EVERY Participant Satisfaction Survey submission.",
          visible: permissions.surveys.participant_satisfaction,
          slug: "participant_satisfaction",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Peer Support Session",
          description:
            "Percent increase/decrease in Peer Support Session Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Peer Support Session Survey at least twice. This metric takes into account ALL Peer Support Session Survey submissions and calculates the average Peer Support Session Survey percent change between EVERY Career Survey submission.",
          visible: permissions.surveys.peer_support_session,
          slug: "peer_support_session",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Discharge Survey",
          description:
            "Percent increase/decrease in Discharge Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Discharge Survey at least twice. This metric takes into account ALL Discharge Survey submissions and calculates the average Discharge Survey percent change between EVERY Career Survey submission.",
          visible: permissions.surveys.discharge_survey,
          slug: "discharge_survey",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Would You Recommend Us?",
          description:
            "Percent increase/decrease in Would You Recommend Us Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Would You Recommend Us Survey at least twice. This metric takes into account ALL Would You Recommend Us Survey submissions and calculates the average Would You Recommend Us Survey percent change between EVERY Would You Recommend Us Survey submission.",
          visible: permissions.surveys.would_you_recommend_us,
          slug: "would_you_recommend_us",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Truly Motivational Transitional Living",
          description:
            "Percent increase/decrease in Truly Motivational Transitional Living Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Truly Motivational Transitional Living Survey at least twice. This metric takes into account ALL Truly Motivational Transitional Living Survey submissions and calculates the average Truly Motivational Transitional Living Survey percent change between EVERY Career Survey submission.",
          visible: permissions.surveys.truly_motivational_transitional_living,
          slug: "truly_motivational_transitional_living",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "RCI - 36",
          description:
            "Percent increase/decrease in RCI - 36 Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the RCI - 36 Survey at least twice. This metric takes into account ALL RCI - 36 Survey submissions and calculates the average RCI - 36 Survey percent change between EVERY Career Survey submission.",
          visible: permissions.surveys.rci_36,
          slug: "rci_36",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "Donation Application",
          description:
            "Percent increase/decrease in Donation Application Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the Donation Application Survey at least twice. This metric takes into account ALL Donation Application Survey submissions and calculates the average Donation Application Survey percent change between EVERY Donation Application Survey submission.",
          visible: permissions.surveys.donation_application,
          slug: "donation_application",
        },
        {
          endpoint: 'average_percent_change_per_month',
          title: "PPM Group Participation Session",
          description:
            "Percent increase/decrease in PPM Group Participation Session Survey total of all eligible clients. In order for a client to be considered eligible in this metric, the client must have taken the PPM Group Participation Session Survey at least twice. This metric takes into account ALL PPM Group Participation Session Survey submissions and calculates the average PPM Group Participation Session Survey percent change between EVERY PPM Group Participation Session Survey submission.",
          visible: permissions.surveys.ppm_group_participation_session,
          slug: "ppm_group_participation_session",
        }
      ],
      exitSurveyMetrics: [
        {
          title: "Maintained Sobriety Percentage",
          format: "number_horizontal",
          endpoint: "maintained_sobriety_percentage",
          visible: permissions.surveys.tres_vista_exit_survey,
        },
        {
          title: "Active in 12 steps",
          format: "number_horizontal",
          endpoint: "active_in_12_steps_percentage",
          visible: permissions.surveys.tres_vista_exit_survey,
        },
        {
          title: "Legal issues post discharge",
          format: "number_horizontal",
          endpoint: "legal_issues_post_discharge_percentage",
          visible: permissions.surveys.tres_vista_exit_survey,
        },
        {
          title: "Families active in alumni support",
          format: "number_horizontal",
          endpoint: "families_active_in_alumni_support_percentage",
          visible: permissions.surveys.tres_vista_exit_survey,
        },
        {
          title: "Alumni residing in a sober living home",
          format: "number_horizontal",
          endpoint: "residing_in_sober_home_percentage",
          visible: permissions.surveys.tres_vista_exit_survey,
        },
      ],
      dischargeSurveyMetrics: [
        {
          title: "Would recommend the program to a friend or loved One",
          format: "number_horizontal",
          endpoint: "would_recommend_percentage",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Overall Staff Rating",
          format: "number_horizontal",
          endpoint: "overall_staff_rating",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Overall Experience",
          format: "number_horizontal",
          endpoint: "overall_experience",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Recovery Activities",
          format: "number_horizontal",
          endpoint: "recovery_activities",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Counseling Sessions",
          format: "number_horizontal",
          endpoint: "counseling_sessions",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Content of Group in Relevance to Needs",
          format: "number_horizontal",
          endpoint: "content_of_group_in_relevance_to_needs",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Knowledge and Professionalism of Counselors",
          format: "number_horizontal",
          endpoint: "knowledge_and_prefessionalism_of_counselors",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Responsiveness of Staff to Treatment Needs",
          format: "number_horizontal",
          endpoint: "responsiveness_of_staff_to_treatment_needs",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Staff Courteousness",
          format: "number_horizontal",
          endpoint: "staff_courteousness",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Living Environment",
          format: "number_horizontal",
          endpoint: "living_environment",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Facility Condition",
          format: "number_horizontal",
          endpoint: "facility_condition",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Welcome and Orientation",
          format: "number_horizontal",
          endpoint: "welcome_and_orientation",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
        {
          title: "Admission Representative",
          format: "number_horizontal",
          endpoint: "admission_representative",
          visible: permissions.surveys.tres_vista_client_discharge_survey,
        },
      ],
      transitionSurveyMetrics: [
        {
          title: "Patients planning on attending an IOP or next level of care",
          format: "number_horizontal",
          endpoint: "patients_planning_iop",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients satisfied with care at Tres Vista ",
          format: "number_horizontal",
          endpoint: "patients_satisfied_with_care",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients treated with dignity and respect",
          format: "number_horizontal",
          endpoint: "patients_treated_with_dignity",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients with quality of life improvement after treatment",
          format: "number_horizontal",
          endpoint: "patients_with_quality_of_life_improv",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title:
              "Patients with family and personal relationship improvement after treatment",
          format: "number_horizontal",
          endpoint: "patients_with_personal_relationship_improv",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients who felt safe with their counselor and therapist",
          format: "number_horizontal",
          endpoint: "patients_who_felt_safe_with_therapist",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients who felt safe with their treatment plan and goals",
          format: "number_horizontal",
          endpoint: "patients_who_felt_safe_with_plans",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients who felt safe in group",
          format: "number_horizontal",
          endpoint: "patients_who_felt_safe_in_group",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients who felt safe at the home",
          format: "number_horizontal",
          endpoint: "patients_who_felt_safe_at_the_home",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
        {
          title: "Patients who felt unsafe in treatment",
          format: "number_horizontal",
          endpoint: "patients_who_felt_unsafe_in_treatment",
          visible: permissions.surveys.tres_vista_resident_transition_survey,
        },
      ],
      basic_metrics: [
        {
          title: "Survey Requests vs Submissions",
          endpoint: "number_of_survey_requests",
          format: "vertical_bar_graph",
          description: "",
          visible: true,
        },
        {
          title: "% of Survey Requests Completed by Clients",
          endpoint: "survey_requests_percentage",
          format: "pie_chart",
          show_percentage: true,
          description: "Percentage of Survey Requests completed",
          visible: true,
        },
      ],
    },
    medical: {
      link: outcomesLink(organization_name, "/medical"),
      name: "Medical",
      visible:
          !permissions.is_only_treatment_center &&
          intersection(services, ["medical_logs"]).length > 0,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          endpoint: "percent_of_clients_on_mat",
          title: "Percent of clients on MATs",
          outcome_slug: "medication_mat",
          description:
              "Percent of clients that have taken suboxone, buprenorphine, vivitrol, naltrexone, and/or methadone with active occupancies within the filter range.",
          dependent_on: "meds",
          visible: true
        },
        {
          endpoint: "percent_of_clients_on_bss",
          outcome_slug: "medication_bss",
          title:
              "Percent of clients on Buprenorphine, Suboxone, and/or Sublocade",
          description:
              "Percent of clients that have taken Buprenorphine, Suboxone, and/or Sublocade with active occupancies within the filter range.",
          dependent_on: "meds",
          visible: permissions.meds.bss,
        },
        {
          endpoint: "percent_of_clients_on_vivitrol",
          title: "Percent of clients on Vivitrol",
          outcome_slug: "medication_vivitrol",
          description:
              "Percent of clients that have taken Vivitrol within the filter range with active occupancies within the filter range.",
          dependent_on: "meds",
          visible: permissions.meds.vivitrol,
        },
        {
          endpoint: "percent_of_clients_on_methadone",
          title: "Percent of clients on Methadone",
          outcome_slug: "medication_methadone",
          description:
              "Percent of clients that have taken Methadone within the filter range with active occupancies within the filter range.",
          dependent_on: "meds",
          visible: permissions.meds.methadone,
        },
      ],
      standardMetrics: [
        {
          outcome_slug: "abuse_experienced_pie_chart",
          title: "Mental Illnesses Experienced by Clients",
          endpoint: "mental_illness_count",
          format: "pie_chart",
          description: "Percent of mental illness experienced by clients.",
          show_percentage: true,
          visible: true,
        },
        {
          outcome_slug: "abuse_experienced_bar_graph",
          title: "Number of Clients Experiencing Mental Illness",
          endpoint: "mental_illness_count",
          dataKey: "value",
          format: "bar_graph",
          description: "",
          visible: true,
        },
        {
          outcome_slug: "health_problem_pie_chart",
          title: "Percent of Clients with Health Issues",
          endpoint: "health_problem_count",
          format: "pie_chart",
          description: "",
          show_percentage: true,
          visible: true,
        },
        {
          outcome_slug: "health_problem_bar_graph",
          title: "Number of Clients Experiencing Health Issues",
          endpoint: "health_problem_count",
          format: "bar_graph",
          description: "",
          dataKey: "value",
          visible: true,
        },
      ],
    },
    "meetings & checkins": {
      link: outcomesLink(organization_name, "/meetings_checkins"),
      name: "Meetings & Checkins",
      visible: true,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Average Number Of Meetings Attended By Clients Per Week",
          outcome_slug: "meetings_average",
          description:
              "Average number of checkins of type meeting per week, where checked in at date occurs, of all clients that held an occupancy within the filter range.",
          format: "number_horizontal_full",
          endpoint: "average_number_of_meetings_attended_by_clients_per_week",
          visible: permissions.client_app.location_services,
        },
        {
          title: "% of Admitted Clients Attending Approved Meetings",
          description: "",
          format: "number_horizontal_full",
          endpoint: "percentage_of_admitted_clients_with_approved_meetings",
          visible: permissions.client_app.location_services,
        },
      ],
    },
    "program length": {
      link: outcomesLink(organization_name, "/program_length"),
      name: "Program Length",
      visible: true,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Average Length Of Program (Number of Days)",
          outcome_slug: "program_length_average_nr_days",
          description:
              "Note: Only takes into account clients who have already been discharged as of the filter range.",
          dataKey: "days",
          format: "number_horizontal_large",
          endpoint: "average_average_length_of_stay",
          visible: true,
        },
        {
          title: "Average Length Of Program (Per Day)",
          outcome_slug: "program_length_average_per_days",
          description:
              "Note: Only takes into account clients who have already been discharged as of the filter range. For example, on [date], counting all the clients who are discharged on [date] or before [date], the average length of program is [#] of days.",
          dataKey: "days",
          format: "line_graph",
          endpoint: "average_length_of_stay",
          visible: true,
        },
      ],
    },
    "reason for discharge": {
      link: outcomesLink(organization_name, "/reasons_for_discharge"),
      name: "Reason for Discharge",
      visible: !permissions.is_only_treatment_center,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Reason For Discharge",
          outcome_slug: "reason_for_discharge_rfd",
          description: "The reason for discharge of clients discharged.",
          format: "vertical_bar_graph",
          dataKey: "value",
          endpoint: "reason_for_discharge",
          visible: true,
        },
      ],
    },
    "medicinal marijuana": {
      link: outcomesLink(organization_name, "/medicinal_marijuana"),
      name: 'Medicinal Marijuana',
      visible: true,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: `Total # of Clients who have a Marijuana Maintenance Card`,
          outcome_slug: `mm_maintenance_card`,
          description: "",
          format: "number_horizontal",
          endpoint: "maintenance_card_count",
          visible: true,
        },
        {
          title: `Total # of Clients who use Marijuana Maintenance for Pain Management`,
          outcome_slug: `mm_maintenance_card_for_pain_management`,
          description: "",
          format: "number_horizontal",
          endpoint: "maintenance_card_for_pain_management_count",
          visible: true,
        },
        {
          title: "Form of Usage",
          outcome_slug: "mm_form_of_usage",
          description: "",
          format: "bar_graph",
          dataKey: "number",
          endpoint: "form_of_usage_bar_chart",
          visible: true,
        },
      ],
    },
    referrals: {
      link: outcomesLink(organization_name, "/referrals"),
      name: "Referrals",
      visible:
          (!permissions.is_only_treatment_center ||
              permissions.has_crm_service) &&
          intersection(services, ["crm"]).length > 0,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Number Of Referrals By Source",
          outcome_slug: "referrals_nr_source",
          description:
              "Number of clients referred by different sources where client was admitted within the filter range.",
          format: "vertical_bar_graph",
          dataKey: "number",
          endpoint: "number_of_referrals_by_source",
          visible: true,
        },
        {
          title: "Number Of Referrals By Source (OLD)",
          outcome_slug: "referrals_nr_source_old",
          description:
              "Number of clients referred by different sources where client was admitted within the filter range.",
          format: "vertical_bar_graph",
          dataKey: "number",
          endpoint: "number_of_referrals_by_source_old",
          visible: permissions.old_referrals,
        },
      ],
    },
    days_sober: {
      link: outcomesLink(organization_name, "/days_sober"),
      name: "Days Sober",
      visible: !permissions.is_only_treatment_center,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Average Number Of Days Clients Are Sober Upon Admit",
          outcome_slug: "sobrieties_upon_admit",
          description:
              "The average difference in days between the first occupancy's admitted at date and the earliest sobriety date associated with the client, of all clients admitted within the filter range.",
          format: "number_horizontal_large",
          endpoint: "average_number_of_days_clients_are_sober_upon_admit",
          visible: true,
        },
        {
          title: "Average Number Of Days Clients Are Sober Upon Discharge",
          outcome_slug: "sobrieties_upon_discharge",
          description:
              "The average difference in days between the last occupancy's discharged at date and the latest sobriety date associated with the client, of all clients discharged within the filter range.",
          format: "number_horizontal_large",
          endpoint: "average_number_of_days_clients_are_sober_upon_discharge",
          visible: true,
        },
        {
          title: "% of Clients Who Don’t Have a Relapse Date Recorded During Facility Length of Stay",
          description: "",
          format: "number_horizontal_full",
          endpoint: "percentage_of_clients_without_relapse_date_during_admission",
          visible: true
        }
      ],
    },
    "substances of choice": {
      link: outcomesLink(organization_name, "/substances_of_choice"),
      name: "Substances Of Choice",
      visible: !permissions.is_only_treatment_center,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Substance Of Choice",
          outcome_slug: "substances_of_choice_soc",
          description:
              "Substances of choice of clients with active occupancies.",
          format: "vertical_bar_graph",
          dataKey: "value",
          endpoint: "substances_of_choice",
          visible: true,
        },
      ],
    },
    "ua/bas": {
      link: outcomesLink(organization_name, "/ua_ba"),
      name: "UA/BAs",
      visible:
          !permissions.is_only_treatment_center &&
          intersection(services, ["ua_ba"]).length > 0,
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Number Of Positive UA/BAs",
          outcome_slug: "ua/ba_positive",
          description:
              "Number of Positive UA/BAs (marked pos, +, positive, or failed).",
          format: "number_horizontal_large",
          endpoint: "number_of_positive_drug_tests",
          visible: permissions.ua_ba,
        },
        {
          title: "Number Of Negative UA/BAs",
          outcome_slug: "ua/ba_negative",
          description:
              "Number of Negative UA/BAs (marked neg, -, negative, 0, or pass).",
          format: "number_horizontal_large",
          endpoint: "number_of_negative_drug_tests",
          visible: permissions.ua_ba,
        },
      ],
    },
    // education: {
    //   link: outcomesLink(organization_name, "/education"),
    //   name: "Education",
    //   visible: !permissions.is_only_treatment_center,
    //   enabledFilters: ALL_FILTERS,
    //   metrics: [
    //     {
    //       title: "Graduation Rate Percentage",
    //       outcome_slug: "education_grp",
    //       description:
    //         "Percent of educational programs that were completed (have a graduation date after the admit date) for clients that were admitted at some point within the filter range.",
    //       format: "number_horizontal_large",
    //       endpoint: "graduation_rate_percentage",
    //       visible: true,
    //     },
    //     {
    //       title: "Average GPA Upon Admit",
    //       outcome_slug: "education_average_gpa_admit",
    //       description:
    //         "Average GPA upon admit of all clients that were in the program at some point within the filter range.",
    //       format: "number_horizontal_large",
    //       endpoint: "average_gpa_upon_move_in",
    //       visible: true,
    //     },
    //     {
    //       title: "Average GPA Upon Discharge",
    //       outcome_slug: "education_average_gpa_discharge",
    //       description:
    //         "Average GPA upon discharge of all clients that were discharged at some point within the filter range.",
    //       format: "number_horizontal_large",
    //       endpoint: "average_gpa_upon_move_out",
    //       visible: true,
    //     },
    //   ],
    // },
    "post general": {
      link: postOutcomesLink(organization_name, ""),
      name: "General",
      enabledFilters: ALL_FILTERS,
      metrics: [
        {
          title: "Number of Discharges",
          outcome_slug: "post_general_nod",
          description: "Number of discharges within the filter range.",
          format: "number_horizontal_full",
          endpoint: "number_of_discharges",
          visible: true,
        },
        {
          title: "Number of Alumni on Client App",
          outcome_slug: "post_general_naca",
          description:
              "How many of my alumni clients still have the client app vs alumni who don't have the client app",
          format: "pie_chart",
          endpoint: "alumni_on_client_app",
          visible: true,
        },
        {
          title: "Average Number of Events Attended by Alumni",
          outcome_slug: "post_general_nod",
          description: "",
          format: "number_horizontal_full",
          endpoint: "count_events_by_alumni",
          visible: true,
        },
        {
          title: "Number of Alumni Referrals",
          outcome_slug: "post_general_noar",
          description: "The number of referrals with an alumni as the source.",
          format: "number_horizontal_full",
          endpoint: "number_of_alumni_referrals",
          visible: true,
        },
        {
          title: "Number of Alumni Contacted",
          outcome_slug: "post_general_noac",
          description: "Number of Alumni that were followed up with.",
          format: "number_horizontal_full",
          endpoint: "number_of_kept_up_with_alumni",
          visible: true,
        },
        {
          title: "Post Discharge Destination",
          outcome_slug: "post_general_post_discharge_destination",
          description: "",
          format: "bar_graph",
          endpoint: "post_discharge_destination",
          visible: true,
        },
        {
          // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
          title: "Number of Relapses",
          description:
              "Number of relapses that occur after the discharge date.",
          format: "number_horizontal_full",
          endpoint: "alumni_number_of_relapses",
          visible: true,
          is_fake: true,
        },
        {
          // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
          title: "Number of Successes",
          description:
              "Number of discharged clients that did not relapse post discharge.",
          format: "number_horizontal_full",
          endpoint: "alumni_number_of_successes",
          visible: true,
          is_fake: true,
        },
        {
          // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
          title: "Average Number of Days Sober Post Discharge",
          description:
              "Average number of days a client is sober post discharge until (if any) relapse date.",
          format: "number_horizontal_full",
          endpoint: "average_number_of_days_sober_post_discharge",
          visible: true,
          is_fake: true,
        },
        {
          // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
          title: "Average Number of Meeting Attended by Alumni per Week",
          description:
              "Average number of meetings attended by alumni that are attending meetings post discharge.",
          format: "number_horizontal_full",
          endpoint: "average_number_of_meetings_attended_by_alumni_per_week",
          visible: true,
          is_fake: true,
        },
        {
          // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
          title: "Percent Employed Post Discharge",
          description:
              "Number of clients employed post discharge of total that have moved out.",
          format: "pie_chart_large",
          endpoint: "percent_employed_post_discharge",
          visible: true,
          is_fake: true,
        },
      ],
    },
  }
  if(organization_name !== 'Transformational-Living-Homes' && organization_name !== 'sober-homes'){
    delete metrics["medicinal marijuana"]
  }

  return metrics;
}
